import React, { useState, useEffect, useRef, useCallback, useMemo, useId } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/store";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Search, Phone, Video, Mic, MicOff, VideoOff,
  Send, Image as ImageIcon, Paperclip, MoreVertical,
  User, Check, CheckCheck, MessageSquare,
  PhoneOff, ArrowLeft, ArrowRight, Menu, Eye, FileText, X,
  Reply, Copy, Flag, Shield
} from "lucide-react";
import ProfileCompletionDialog from "../components/ui/ProfileCompletionDialog";
import VerificationRequirementDialog from "../components/VerificationRequirementDialog";
import { useVerification } from "../hooks/useVerification";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "../components/ui/Button";
import { Badge } from "../components/ui/badge";
import SharedHeader4 from "../Headers/SharedHeader4";
import { useTranslation } from "react-i18next";
import { validateMessage, checkContractContext } from "../utils/chatRuleValidation";
import { fetchChatRules, createChatRuleLog } from "../redux/Slices/ChatRulesSlice";
import { ChatRule, ChatRuleLogCreateDto, ChatRuleTypeEnum } from "../modules/shared/model";
import { fetchContracts } from "../redux/Slices/contractSlice";
import SharedFooter3 from "../Footer/SharedFooter3";
import SharedHeader from "../Headers/SharedHeader";
import {
  fetchParticipantChats,
  fetchChatMessages,
  sendMessage,
  updateChat,
  sendConversation,
  fetchConversations,
  uploadChatFile,
  createProfessionalChat,
  checkChatBetweenParticipants
} from "../redux/Actions/ChatActions";
import { createChat, createConversation } from "../redux";
import {
  setSelectedChat,
  setSearchQuery,
  clearMessages,
  clearConversations,
  clearUploadedFiles,
  removeUploadedFile,
  updateChatInList,
  addChatToTop,
  handleWebSocketMessage as handleWebSocketMessageAction,
  setReplyToMessage,
  clearReplyToMessage
} from "../redux/Slices/chatSlice";
import { RootState } from "../redux/store";
import { AgoraVideoCallWithControls } from "../components/VideoCall/AgoraVideoCallWithControls";
import { CallType } from "../config/agoraConfig";
import { useCallManager } from "../hooks/useCallManager";
import { CallInProgressBanner } from "../components/VideoCall/CallInProgressBanner";
import SharedHeader2 from "../Headers/SharedHeader2";
import MyProfile from "../modules/professional/components/MyProfile";
import { OfferTimelineTypeEnum, RequestQuoteModal } from "../components/ui";
import ContractDetailModal from "../components/ui/ContractDetailModal";
import PaymentRequestModal from "../components/ui/PaymentRequestModal";
import RejectionDetailsDialog from "../components/ui/RejectionDetailsDialog";
import ClientProfile1 from "../modules/client/components/ClientProfile1";
import SharedHeader6 from "../Headers/SharedHeader6";
import { RoleEnum, ConversationTypeEnum, ContractStatusEnum, MilestoneStatusEnum, MilestonePaymentStatusEnum, ContextEnum } from "../modules";
import { ChatStatusEnum } from "../modules/shared/model/ChatInterfaces";
import { getJobById } from "../redux";
import { fetchOffer } from "../redux/Slices/offerSlice";
import { useWebSocket } from "../hooks/useWebSocket";
import { EscrowStatus } from "../services/escrowAPI";
import {
  canAcceptDeclineContract,
  requiresTrackerCheckbox,
  defaultHandleContractAction
} from "../utils/contractUtils";
import { createMilestonePaymentLog } from "../redux/Slices/contractSlice";
import { MilestonePaymentLogCreateDto } from "../modules/shared/model";
import { escrowAPI } from "../services/escrowAPI";
import { GlobalService } from "../modules";
import OfferDetailsModal from "../components/ui/OfferDetailsModal";
import ClientOfferDetailsModal from "../components/ui/ClientOfferDetailsModal";
import ContractMilestoneModal from "../components/ui/ContractMilestoneModal";
import { fetchUserOffers } from "../redux/Slices/offerSlice";
import SharedHeader5 from "../Headers/SharedHeader5";
import { trackActivity, checkCanCommunicate } from "../redux/Actions/ProfessionalMonitoringActions";
import ChatSafetyNoticeDialog from "../components/ui/ChatSafetyNoticeDialog";

// Helper: get other participant (not current user, not admin)
const getNonAdminOtherParticipantFromContainer = (container: any, currentUserId?: string) => {
  const participants = container?.chat?.participants || container?.participants || [];
  if (!participants || participants.length === 0) return null;
  return (
    participants.find((p: any) => {
      const roleId = (p?.role && (p.role.id || p.role)) || p?.roleId;
      return p?.id !== currentUserId && Number(roleId) !== 1;
    }) || participants.find((p: any) => p?.id !== currentUserId)
  ) || null;
};

const MessagesAndVideoCall2 = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const uploadId = useId();
  const chatImageUploadId = `${uploadId}-chat-image`;
  const chatFileUploadId = `${uploadId}-chat-file`;
  const [searchParams] = useSearchParams();
  const { chats, selectedChat, messages, conversations, uploadedFiles, loading, error, searchQuery, pagination, replyToMessage, conversationPagination, conversationsLoading } = useSelector((state: RootState) => state.chat);
  const { user } = useSelector((state: RootState) => state.auth);
  const { settings: categoryFormSettings } = useSelector((state: RootState) => state.categoryFormSettings);
  const { chatRules } = useSelector((state: RootState) => state.chatRules);
  const { items: contracts } = useSelector((state: RootState) => state.contracts);
  
  // Create a ref for conversations to avoid stale closures
  const conversationsRef = useRef(conversations);


  const [message, setMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isInCall, setIsInCall] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  const [typingUsers, setTypingUsers] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [isCurrentlyTyping, setIsCurrentlyTyping] = useState(false);
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [chatListKey, setChatListKey] = useState(0);
  const [localChats, setLocalChats] = useState<any[]>([]);
  const [isUploadMenuOpen, setIsUploadMenuOpen] = useState(false);
  const [isProfilePopoverOpen, setIsProfilePopoverOpen] = useState(false);
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showContractDetailModal, setShowContractDetailModal] = useState(false);
  const [selectedContractEscrow, setSelectedContractEscrow] = useState(null);
  const [showPaymentRequestModal, setShowPaymentRequestModal] = useState(false);
  const [selectedPaymentRequest, setSelectedPaymentRequest] = useState(null);
  const [selectedMilestoneId, setSelectedMilestoneId] = useState<string | null>(null);
  const [selectedProfessional, setSelectedProfessional] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [callType, setCallType] = useState<CallType>(CallType.VIDEO);
  const [channelName, setChannelName] = useState<string>("");
  const [hasExplicitlyLeftCall, setHasExplicitlyLeftCall] = useState<boolean>(false);
  const [showOfferDialog, setShowOfferDialog] = useState(false);
  const [offerDetails, setOfferDetails] = useState<any>(null);
  const [showOfferDetailsModal, setShowOfferDetailsModal] = useState(false);
  const [selectedOfferDetails, setSelectedOfferDetails] = useState<any>(null);
  const [showClientOfferModal, setShowClientOfferModal] = useState(false);
  const [selectedClientOffer, setSelectedClientOffer] = useState<any>(null);
  const [showCreateContractModal, setShowCreateContractModal] = useState(false);
  const [selectedOfferForContract, setSelectedOfferForContract] = useState<any>(null);
  const [showRejectionDialog, setShowRejectionDialog] = useState(false);
  const [selectedRejectionData, setSelectedRejectionData] = useState<any>(null);
  
  // Contract modal state
  const [showContractMilestoneModal, setShowContractMilestoneModal] = useState(false);
  const [clientOffers, setClientOffers] = useState([]);
  const [selectedContractOffer, setSelectedContractOffer] = useState(null);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [showFullScreenLoader, setShowFullScreenLoader] = useState(false);
  const [localActiveCalls, setLocalActiveCalls] = useState<any[]>([]);
  const [uploadingFiles, setUploadingFiles] = useState<Set<string>>(new Set());
  const [uploadProgress, setUploadProgress] = useState<{ [key: string]: number }>({});
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [isLoadingOlderConversations, setIsLoadingOlderConversations] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const messageContainerRef = useRef<HTMLDivElement>(null);
  const isLoadingOlderRef = useRef(false);
  const previousScrollHeightRef = useRef<number | null>(null);
  const previousScrollTopRef = useRef<number | null>(null);
  const CONVERSATION_PAGE_SIZE = 10;
  const [currentCallId, setCurrentCallId] = useState<string | null>(null);
  const [hasAnyoneJoinedCall, setHasAnyoneJoinedCall] = useState(false);

  // Profile and verification dialog states
  const [showProfileCompletionDialog, setShowProfileCompletionDialog] = useState(false);
  const [showVerificationDialog, setShowVerificationDialog] = useState(false);
  
  // Chat safety notice dialog state
  const [showChatSafetyNotice, setShowChatSafetyNotice] = useState(false);
  
  // Use verification hook
  const { isVerified, goToVerification, verificationData } = useVerification();
  
  // Track if verification data has been loaded at least once
  const [verificationDataLoaded, setVerificationDataLoaded] = useState(false);

  // Boolean flags to prevent multiple executions
  const [canProcessConversation, setCanProcessConversation] = useState(true);
  const [canProcessCallInitiated, setCanProcessCallInitiated] = useState(true);
  const [canProcessCallEnded, setCanProcessCallEnded] = useState(true);
  const [canProcessUserLeftCall, setCanProcessUserLeftCall] = useState(true);

  // Refs to always access latest values in WebSocket callbacks (avoids closure issues)
  const selectedChatRef = useRef(selectedChat);
  const userRef = useRef(user);
  const currentCallIdRef = useRef(currentCallId);
  const hasAnyoneJoinedCallRef = useRef(hasAnyoneJoinedCall);
  const isInCallRef = useRef(isInCall);
  const callTypeRef = useRef(callType);
  const chatsRef = useRef(chats);
  
  // Update refs synchronously on every render to ensure callbacks always have latest values
  selectedChatRef.current = selectedChat;
  userRef.current = user;
  currentCallIdRef.current = currentCallId;
  hasAnyoneJoinedCallRef.current = hasAnyoneJoinedCall;
  isInCallRef.current = isInCall;
  callTypeRef.current = callType;
  chatsRef.current = chats;
  conversationsRef.current = conversations;

  // Scroll to bottom function
  const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  // Helper functions for chat safety notice tracking
  const hasSeenChatSafetyNotice = useCallback((chatId: string, userId: string): boolean => {
    if (!chatId || !userId) return true; // If no valid IDs, don't show notice
    const key = `chat_safety_notice_${userId}_${chatId}`;
    return localStorage.getItem(key) === "true";
  }, []);

  const markChatSafetyNoticeSeen = useCallback((chatId: string, userId: string) => {
    if (!chatId || !userId) return;
    const key = `chat_safety_notice_${userId}_${chatId}`;
    localStorage.setItem(key, "true");
  }, []);

  const handleAcceptSafetyNotice = useCallback(() => {
    if (selectedChat?.chat?.id && user?.id) {
      markChatSafetyNoticeSeen(selectedChat.chat.id, user.id);
      setShowChatSafetyNotice(false);
    }
  }, [selectedChat, user, markChatSafetyNoticeSeen]);

  const setConversations = useCallback((message: any) => {
    console.log("📨 setConversations called with message:", message.detail?.conversationId);
    
    // Extract conversation data from message
    const conversationData = message.detail?.conversation;
    const conversationId = conversationData?.id || message.detail?.conversationId;
    const chatId = message.detail?.chatId;
    
    if (!conversationData || !conversationId || !chatId) {
      console.error("❌ Invalid message format - missing conversation data:", message);
      return;
    }
    
    console.log("🔍 Processing conversation:", {
      conversationId,
      chatId,
      currentConversations: conversationsRef.current.length
    });
    
    // Check if this conversation already exists to prevent duplicates using ref
    const conversationExists = conversationsRef.current.some((conv: any) => conv.id === conversationId);
    
    if (conversationExists) {
      console.log("⏸️ Conversation already exists, skipping:", conversationId);
      return;
    }
    
    console.log("➕ Processing new conversation in Redux");
    
    // Always dispatch the WebSocket message to update chat list
    // The Redux reducer will handle adding to conversations only if it's the selected chat
    dispatch(handleWebSocketMessageAction({
      sender: conversationData.sender?.id || "",
      type: "new_conversation",
      timestamp: conversationData.createdAt || new Date().toISOString(),
      detail: {
        conversationId: conversationData.id,
        chatId: chatId,
        message: conversationData.message || "",
        senderId: conversationData.sender?.id,
        attachments: conversationData.attachments || [],
        type: conversationData.type?.id || 1,
        referenceId: conversationData.referenceId,
        timestamp: conversationData.createdAt || new Date().toISOString(),
        conversation: conversationData
      }
    }));
    
    console.log("✅ Conversation dispatched to Redux");
    
    // If this is the currently selected chat, scroll to bottom
    if (selectedChatRef.current?.chat?.id === chatId) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [dispatch, scrollToBottom]);

  // Handle conversations without flag - duplicate checking is now done in setConversations
  const handleConversationWithFlag = useCallback((message: any) => {
    console.log("📨 handleConversationWithFlag called");
    setConversations(message);
  }, [setConversations]);

  const loadOlderConversations = useCallback(async () => {
    if (!selectedChat?.chat?.id) return;
    if (!conversationPagination?.hasNextPage) return;

    const container = messageContainerRef.current;
    if (!container) return;
    if (isLoadingOlderRef.current) return;

    const nextPage = (conversationPagination?.page || 1) + 1;

    isLoadingOlderRef.current = true;
    setIsLoadingOlderConversations(true);
    previousScrollHeightRef.current = container.scrollHeight;
    previousScrollTopRef.current = container.scrollTop;

    try {
      await dispatch(
        fetchConversations({
          chatId: selectedChat.chat.id,
          page: nextPage,
          limit: CONVERSATION_PAGE_SIZE,
          isShowLoader: false,
        }),
      ).unwrap();
    } catch (error) {
      console.error("Failed to load older conversations:", error);
      isLoadingOlderRef.current = false;
      setIsLoadingOlderConversations(false);
      previousScrollHeightRef.current = null;
      previousScrollTopRef.current = null;
    }
  }, [CONVERSATION_PAGE_SIZE, conversationPagination?.hasNextPage, conversationPagination?.page, dispatch, selectedChat?.chat?.id]);

  const handleMessageScroll = useCallback(() => {
    const container = messageContainerRef.current;
    if (!container) return;
    if (isLoadingOlderRef.current) return;
    if (!conversationPagination?.hasNextPage) return;

    const threshold = 150;
    if (container.scrollTop <= threshold) {
      loadOlderConversations();
    }
  }, [conversationPagination?.hasNextPage, loadOlderConversations]);

  useEffect(() => {
    if (
      isLoadingOlderRef.current &&
      messageContainerRef.current &&
      previousScrollHeightRef.current !== null &&
      previousScrollTopRef.current !== null
    ) {
      const container = messageContainerRef.current;
      const heightDiff = container.scrollHeight - previousScrollHeightRef.current;
      container.scrollTop = previousScrollTopRef.current + heightDiff;

      previousScrollHeightRef.current = null;
      previousScrollTopRef.current = null;
      isLoadingOlderRef.current = false;
      setIsLoadingOlderConversations(false);
    }
  }, [conversations]);

  // Throttled function for fetching participant chats
  const handleFetchParticipantChatsWithFlag = useCallback((currentUserId: string) => {
    console.log("📋 handleFetchParticipantChatsWithFlag called, canProcess:", canProcessConversation);
    
    // Skip if already processing
    if (!canProcessConversation) {
      console.log("⏸️ Already processing, skipping fetch");
      return;
    }
    
    setCanProcessConversation(false);
    dispatch(fetchParticipantChats({ currentUserId, page: 1, limit: 10 }));
    
    // Reduced timeout to 2 seconds to be less aggressive
    setTimeout(() => {
      setCanProcessConversation(true);
      console.log("✅ Ready to process next fetch");
    }, 2000);
  }, [canProcessConversation, dispatch]);

  // Flag-based function for handling call initiated notifications
  const handleCallInitiatedWithFlag = useCallback((callData: any) => {
    if (!canProcessCallInitiated) return;
    
    setCanProcessCallInitiated(false);
    
    // Validate call is not too old (max 5 minutes)
    const callTimestamp = new Date(callData.createdAt || callData.startedAt).getTime();
    const now = Date.now();
    const maxCallAge = 5 * 60 * 1000; // 5 minutes in milliseconds
    
    if (now - callTimestamp > maxCallAge) {
      console.log("⏰ Ignoring stale call notification (older than 5 minutes):", callData.id);
      setCanProcessCallInitiated(true);
      return;
    }
    
    setLocalActiveCalls(prev => {
      const exists = prev.some(call => call.id === callData.id);
      if (!exists) {
        return [...prev, callData];
      }
      return prev;
    });
    
    setTimeout(() => {
      setCanProcessCallInitiated(true);
    }, 5000);
  }, [canProcessCallInitiated]);

  // Flag-based function for handling call ended notifications
  const handleCallEndedWithFlag = useCallback((callId: string, chatId: string) => {
    if (!canProcessCallEnded) return;
    
    setCanProcessCallEnded(false);
    setLocalActiveCalls(prev => prev.filter(call => call.id !== callId));
    if (selectedChatRef.current?.chat?.id === chatId) {
      setHasExplicitlyLeftCall(true);
    }
    
    setTimeout(() => {
      setCanProcessCallEnded(true);
    }, 5000);
  }, [canProcessCallEnded]);

  // Flag-based function for handling user left call notifications
  const handleUserLeftCallWithFlag = useCallback((chatId: string, leftBy: string) => {
    if (!canProcessUserLeftCall) return;
    
    setCanProcessUserLeftCall(false);
    
    // Only show banner if:
    // 1. It's for the current chat
    // 2. It's not the current user who left
    // 3. Current user is still in the call (hasn't left/ended yet)
    if (selectedChatRef.current?.chat?.id === chatId && 
        leftBy !== userRef.current?.id && 
        isInCallRef.current === true) {
      setHasExplicitlyLeftCall(false);
    }
    
    setTimeout(() => {
      setCanProcessUserLeftCall(true);
    }, 5000);
  }, [canProcessUserLeftCall]);

  // Store handler functions in refs for stable callbacks
  const handleConversationWithFlagRef = useRef(handleConversationWithFlag);
  const handleFetchParticipantChatsWithFlagRef = useRef(handleFetchParticipantChatsWithFlag);
  const handleCallInitiatedWithFlagRef = useRef(handleCallInitiatedWithFlag);
  const handleCallEndedWithFlagRef = useRef(handleCallEndedWithFlag);
  const handleUserLeftCallWithFlagRef = useRef(handleUserLeftCallWithFlag);

  // Update handler refs when they change
  useEffect(() => {
    handleConversationWithFlagRef.current = handleConversationWithFlag;
    handleFetchParticipantChatsWithFlagRef.current = handleFetchParticipantChatsWithFlag;
    handleCallInitiatedWithFlagRef.current = handleCallInitiatedWithFlag;
    handleCallEndedWithFlagRef.current = handleCallEndedWithFlag;
    handleUserLeftCallWithFlagRef.current = handleUserLeftCallWithFlag;
  }, [handleConversationWithFlag, handleFetchParticipantChatsWithFlag, handleCallInitiatedWithFlag, handleCallEndedWithFlag, handleUserLeftCallWithFlag]);

  // Stable onMessageSent callback
  const handleMessageSent = useCallback((response: any) => {
    console.log("✅ Message sent 11111confirmation:", response);
    if (response.success && response.detail && response.detail.type === "new_conversation") {
      if (userRef.current?.id) {
        handleConversationWithFlagRef.current(response.detail);
      }
      else {
        handleFetchParticipantChatsWithFlagRef.current(userRef.current?.id);
      }
    }
  }, []);

  // Stable onMessage callback
  const handleWebSocketMessage = useCallback(async (message) => {
      console.log("📨 WebSocket message received in MessagesAndVideoCall:", message);
      
      // Handle conversation messages
      if (message.type === "new_conversation") {
        try {
          console.log("💬 Processing new_conversation message");
          
          // Always process the conversation message
          if (userRef.current?.id) {
            console.log("👤 User ID exists, processing conversation");
            handleConversationWithFlagRef.current(message);
          } else {
            console.log("⚠️ No user ID, fetching chats");
            handleFetchParticipantChatsWithFlagRef.current(userRef.current?.id);
          }
        } catch (error) {
          console.error("❌ Error in new_conversation handler:", error);
        }
        return; // Early return to prevent processing other handlers
      }

      // Handle call initiated notification
      if (message.type === "call_initiated") {
        try {
          const { callId, chatId, callType, initiatedBy, channelName, participantIds, initiator, participants } = message.detail;

          // Create call object for the banner
          const callData = {
            id: callId,
            chatId,
            callType,
            initiatedBy,
            channelName,
            participantIds,
            createdAt: message.detail.timestamp,
            startedAt: message.detail.timestamp,
            initiator,
            participants: participants || [],
            status: "active",
            maxParticipants: 10
          };

          // Use flag-based function to add to active calls
          handleCallInitiatedWithFlagRef.current(callData);
        } catch (error) {
          console.error("❌ Error in call_initiated handler:", error);
        }
        return; // Early return
      }

      // Handle user joined call notification
      if (message.type === "user_joined_call") {
        try {
          const { callId } = message.detail;
          // Mark that someone has joined the call
          if (currentCallIdRef.current === callId) {
            setHasAnyoneJoinedCall(true);
          }
        } catch (error) {
          console.error("❌ Error in user_joined_call handler:", error);
        }
        return; // Early return
      }

      // Handle typing indicator
      if (message.type === "typing") {
        try {
          const { chatId, userId, userName, isTyping: userIsTyping } = message.detail;
          // Use refs to get latest values (avoids closure issues)
          const currentSelectedChat = selectedChatRef.current;
          const currentUser = userRef.current;

          // Only show typing indicator for the current selected chat
          if (currentSelectedChat?.chat?.id === chatId && userId !== currentUser?.id) {
            setTypingUsers(prev => {
              if (userIsTyping) {
                // Add or update typing user
                const existingUserIndex = prev.findIndex(u => u.userId === userId);
                if (existingUserIndex >= 0) {
                  // Update existing user
                  const updated = [...prev];
                  updated[existingUserIndex] = { userId, userName, timestamp: Date.now() };
                  return updated;
                } else {
                  // Add new user
                  return [...prev, { userId, userName, timestamp: Date.now() }];
                }
              } else {
                // Remove user from typing list
                return prev.filter(u => u.userId !== userId);
              }
            });
          }
        } catch (error) {
          console.error("❌ Error in typing handler:", error);
        }
        return; // Early return
      }

      // Handle call ended notification
      if (message.type === "call_ended") {
        try {
          const { callId, chatId, endedBy } = message.detail;

          // Remove from local active calls immediately
          setLocalActiveCalls(prev => prev.filter(call => call.id !== callId));

          // Use flag-based function to handle call ended
          handleCallEndedWithFlagRef.current(callId, chatId);
        } catch (error) {
          console.error("❌ Error in call_ended handler:", error);
        }
        return; // Early return
      }

      // Handle user left call notification
      if (message.type === "user_left_call") {
        try {
          const { callId, chatId, leftBy } = message.detail;

          // Use flag-based function to handle user left call
          handleUserLeftCallWithFlagRef.current(chatId, leftBy);
        } catch (error) {
          console.error("❌ Error in user_left_call handler:", error);
        }
        return; // Early return
      }

      // Handle chat status update notification from admin
      if (message.type === "chat_status_updated") {
        try {
          const { chatId, newStatus, statusName } = message.detail;

          // Update the chat in the chats list
          const currentChats = chatsRef.current;
          const chatToUpdate = currentChats.find(chat => chat?.chat?.id === chatId);
          
          if (chatToUpdate) {
            console.log("✅ Chat status updated:", chatId, "->", statusName);
            
            // Create updated chat object with new status
            const updatedChat = {
              ...chatToUpdate,
              chat: {
                ...chatToUpdate.chat,
                status: { id: newStatus }
              }
            };

            // Update the chat in the Redux state without triggering a full refresh
            dispatch(updateChatInList({ chatId: chatToUpdate.id, updatedChat }));

            // If this is the currently selected chat, update it immediately
            if (selectedChatRef.current?.chat?.id === chatId) {
              dispatch(setSelectedChat(updatedChat));
            }
          }
        } catch (error) {
          console.error("❌ Error handling chat status update:", error);
        }
        return; // Early return
      }
    }, []); // Empty dependency array - callback never changes

  // Memoize WebSocket options to prevent unnecessary re-registrations
  const webSocketOptions = useMemo(() => ({
    onMessageSent: handleMessageSent,
    onMessage: handleWebSocketMessage,
    onConnect: () => {
      // WebSocket connected
    },
    onDisconnect: () => {
      // WebSocket disconnected
    },
    onError: (error) => {
      console.error("WebSocket error:", error);
    }
  }), [handleMessageSent, handleWebSocketMessage]);

  // WebSocket integration with stable options
  const { isConnected: isWebSocketConnected, hasAuthError: isWebSocketAuthError, error: webSocketError, sendMessage: sendWebSocketMessage } = useWebSocket(webSocketOptions);

  // Call management for multi-participant calls
  const {
    activeCalls,
    currentCall,
    isInCall: isInManagedCall,
    hasActiveCallInChat,
    initiateCall,
    joinCall: joinManagedCall,
    leaveCall,
    endCall
  } = useCallManager({
    userId: user?.id || null,
    chatId: selectedChat?.chat?.id,
    onCallInitiated: (call) => {
      setChannelName(call.channelName);
      setIsInCall(true);
    },
    onCallJoined: (call) => {
      setChannelName(call.channelName);
      setIsInCall(true);
    },
    onCallLeft: (callId) => {
      setIsInCall(false);
      setChannelName("");
      // Show banner when user leaves call (but call is still active)
      setHasExplicitlyLeftCall(false);
    },
    onCallEnded: (callId) => {
      setIsInCall(false);
      setChannelName("");
      // Hide banner when call ends (either by initiator or naturally)
      setHasExplicitlyLeftCall(true);

      // Remove the call from local active calls
      setLocalActiveCalls(prev => prev.filter(call => call.id !== callId));
    },
    onError: (error) => {
      console.error("❌ Call management error:", error);
      // You could show a toast notification here
    }
  });

  const mapOfferFromAPI = (apiOffer: any) => {
    // Safety check for undefined or null apiOffer
    if (!apiOffer) {
      console.warn("mapOfferFromAPI: apiOffer is undefined or null");
      return null;
    }

    const timelineTypeOptions = [
      { id: OfferTimelineTypeEnum.Hour, name: "Hours" },
      { id: OfferTimelineTypeEnum.Day, name: "Days" },
      { id: OfferTimelineTypeEnum.Week, name: "Weeks" }
    ];

    const body = {
      id: apiOffer.id || apiOffer.offerId,
      type: Number(apiOffer.user.role.id) === RoleEnum.professional ? "local" : "international", // Assuming job has a type field
      jobTitle: apiOffer.title || apiOffer.job?.title || "Untitled Job",
      description: apiOffer.user.bio || "",
      origionalOffer: apiOffer,
      professional: apiOffer.user ? {
        id: apiOffer.user.id,
        name: (apiOffer.user.name || (apiOffer.user.firstName && apiOffer.user.lastName ? `${apiOffer.user.firstName} ${apiOffer.user.lastName}` : "Unknown Professional")) || "Unknown Professional",
        rating: apiOffer.user.rating || 0,
        reviews: apiOffer.user.reviews || 0,
        completedJobs: apiOffer.user.completedJobs || 0,
        verified: apiOffer.user.verified || false,
        location: apiOffer.user.province && apiOffer.user.country ? (apiOffer.user.country.name + ", " + apiOffer.user.province) : "Unknown",
        responseRate: (typeof apiOffer.user.responseRate === "string" ? apiOffer.user.responseRate : "N/A") || "N/A",
        avgResponseTime: (typeof apiOffer.user.avgResponseTime === "string" ? apiOffer.user.avgResponseTime : "N/A") || "N/A"
      } : null,
      client: apiOffer.job?.user ? {
        name: (apiOffer.job.user.name || (apiOffer.job.user.firstName && apiOffer.job.user.lastName ? `${apiOffer.job.user.firstName} ${apiOffer.job.user.lastName}` : "Unknown User")) || "Unknown User",
        location: (typeof apiOffer.job.user.location === "string" ? apiOffer.job.user.location : "Unknown") || "Unknown",
        memberSince: apiOffer.job.user.createdAt ? new Date(apiOffer.job.user.createdAt).getFullYear().toString() : "Unknown"
      } : null,
      offer: {
        amount: apiOffer.amount || apiOffer.job?.budget || 0,
        currency: apiOffer.job?.currency?.initial || apiOffer.job?.currency?.name || apiOffer.currency?.initial || apiOffer.currency?.name || "USD",
        timeline: `${apiOffer.timeline || 1} ${timelineTypeOptions.find(type => type?.id === Number(apiOffer.timelineType?.id))?.name || "days"}`,
        timelineType: apiOffer.timelineType,
        status: (typeof apiOffer.status.id === "string" ? parseInt(apiOffer.status.id) : apiOffer.status.id) || 2,
        sentAt: apiOffer.createdAt || new Date().toISOString(),
        validUntil: apiOffer.validUntil || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
        files: apiOffer.files ? apiOffer.files : [],
        job: apiOffer.job,
        user: apiOffer.user,
        // Additional fields for local services
        availability: apiOffer.availability || [],
        includesPartsAndMaterials: apiOffer.isPartsIncluded || false,
        warranty: apiOffer.isWarranty ? "30 days" : "No warranty",
        // Additional fields for international services
        milestones: apiOffer.milestones || []
      },
      coverLetter: apiOffer.description || "No cover letter provided",
      attachments: apiOffer.files?.map((file: any) => ({
        id: file.id,
        name: file.name || file.path?.split("/").pop() || `File ${file.id}`,
        url: file.path || file.url || "",
        type: file.type || "application/octet-stream"
      }))
    };
    return body;
  };


  // Effect to handle screen size changes
  React.useEffect(() => {
    const handleResize = () => {
      // Mobile: < 640px, Tablet: 640px - 1024px, Desktop: > 1024px
      const isMobile = window.innerWidth < 640;
      const isTablet = window.innerWidth >= 640 && window.innerWidth < 1024;
      const isDesktop = window.innerWidth >= 1024;

      setIsMobileView(isMobile);

      // Auto-open sidebar on tablet and desktop
      if (isTablet || isDesktop) {
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Effect to handle mobile keyboard opening for better visibility
  React.useEffect(() => {
    if (!isMobileView) return;

    const initialViewportHeight = window.visualViewport?.height || window.innerHeight;

    const handleViewportChange = () => {
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      const heightDifference = initialViewportHeight - currentHeight;

      // If viewport height decreased by more than 150px, keyboard is likely open
      const keyboardOpen = heightDifference > 150;

      // Scroll to bottom when keyboard opens to ensure input area is visible
      if (keyboardOpen) {
        setTimeout(() => {
          scrollToBottom();
        }, 100);
      }
    };

    // Use Visual Viewport API if available (better for mobile)
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportChange);
      return () => window.visualViewport?.removeEventListener("resize", handleViewportChange);
    } else {
      // Fallback to window resize
      window.addEventListener("resize", handleViewportChange);
      return () => window.removeEventListener("resize", handleViewportChange);
    }
  }, [isMobileView, scrollToBottom]);

  // Effect to close upload menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isUploadMenuOpen && !(event.target as Element).closest(".upload-menu-container")) {
        setIsUploadMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isUploadMenuOpen]);

  // Effect to close profile popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isProfilePopoverOpen && !(event.target as Element).closest(".profile-popover-container")) {
        setIsProfilePopoverOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfilePopoverOpen]);

  // Effect to clean up old typing users (remove after 5 seconds of inactivity)
  useEffect(() => {
    const cleanupInterval = setInterval(() => {
      const now = Date.now();
      setTypingUsers(prev =>
        prev.filter(user => now - user.timestamp < 5000)
      );
    }, 1000);

    return () => clearInterval(cleanupInterval);
  }, []);

  // Cleanup typing timeouts on component unmount
  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  // Scroll to bottom when selected chat changes
  useEffect(() => {
    if (selectedChat) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [selectedChat, scrollToBottom]);

  // Auto-select first chat when chats are loaded (but only once)
  const hasAutoSelectedRef = useRef(false);
  useEffect(() => {
    // Don't auto-select if there's a selectedUserId parameter (it will be handled by the selectedUserId effect)
    const selectedUserId = searchParams.get("selectedUserId");
    if (selectedUserId) {
      console.log("⏸️ Skipping auto-select: selectedUserId parameter present");
      return;
    }
    
    if (chats.length > 0 && !hasAutoSelectedRef.current && !selectedChat) {
      console.log("🎯 Auto-selecting first chat");
      handleChatSelect(chats[0]);
      hasAutoSelectedRef.current = true;
    }
  }, [chats.length, selectedChat, searchParams]); // Only depend on chats.length and selectedChat



  // Effect to fetch chats, chat rules, and contracts when component mounts
  useEffect(() => {
    if (user?.id) {
      dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
      // Fetch active chat rules for validation
      dispatch(fetchChatRules({}));
      // Fetch contracts for contract-based rule validation
      // Use the same pattern as MyOrdersPage.tsx and myorders.tsx
      const query: any = { 
        page: 1, 
        limit: 1, // Get more contracts for better rule validation
        sort: JSON.stringify([{ orderBy: "createdAt", order: "DESC" }])
      };
      
      // Add user-specific filter based on role
      const roleId = Number(user.role?.id);
      if (roleId === 2 || roleId === 4) { // Client or International Client
        query.clientId = user.id;
      } else if (roleId === 3 || roleId === 5) { // Professional or International Professional
        query.professionalId = user.id;
      }
      
      dispatch(fetchContracts(query));
    }
  }, [dispatch, user?.id]);

  // Refs to track URL parameter processing
  const urlParamsProcessedRef = useRef(false);
  const isFirstRenderRef = useRef(true);
  const selectedUserIdProcessedRef = useRef<string | null>(null);
  const professionalIdProcessedRef = useRef<string | null>(null);
  const isProcessingUrlRef = useRef(false);

  // Set isFirstRenderRef to false after component mounts
  useEffect(() => {
    isFirstRenderRef.current = false;
  }, []);

  // Effect to show chat safety notice when a chat is selected for the first time
  useEffect(() => {
    if (selectedChat?.chat?.id && user?.id) {
      const chatId = selectedChat.chat.id;
      const userId = user.id;
      
      // Check if user has seen the safety notice for this chat
      if (!hasSeenChatSafetyNotice(chatId, userId)) {
        // Small delay to ensure chat is fully loaded before showing the modal
        const timer = setTimeout(() => {
          setShowChatSafetyNotice(true);
        }, 500);
        
        return () => clearTimeout(timer);
      }
    }
  }, [selectedChat?.chat?.id, user?.id, hasSeenChatSafetyNotice]);

  // Effect to handle selectedUserId from URL parameters
  useEffect(() => {
    const selectedUserId = searchParams.get("selectedUserId");

    console.log("🔄 selectedUserId effect triggered:", {
      selectedUserId,
      userId: user?.id,
      isFirstRender: isFirstRenderRef.current,
      chatsLength: chats.length,
      alreadyProcessed: selectedUserIdProcessedRef.current
    });

    // Only process if we have selectedUserId parameter
    if (!selectedUserId || !user?.id) {
      console.log("⏸️ Skipping: No selectedUserId or user.id");
      return;
    }

    // If this is the first render, return early and wait for chats to load
    if (isFirstRenderRef.current) {
      console.log("⏸️ Skipping: First render, waiting for chats to load");
      return;
    }

    // Wait for chats to load before processing
    if (chats.length === 0 && !loading) {
      console.log("⏸️ Skipping: Chats not loaded yet");
      return;
    }

    // If we've already processed this exact selectedUserId, don't process again
    if (selectedUserIdProcessedRef.current === selectedUserId) {
      console.log("⏸️ Skipping: Already processed this selectedUserId");
      return;
    }

    // Mark as processed to prevent duplicate execution
    selectedUserIdProcessedRef.current = selectedUserId;

    // Async function to handle chat search and creation
    const handleSelectedUserChat = async () => {
      try {
        // Show loading state
        setShowFullScreenLoader(true);
        
        console.log("🔍 Looking for chat between:", user.id, "and", selectedUserId);
        console.log("📋 Total chats loaded:", chats.length);
        
        // Step 1: Check if chat already exists in local chats array
        let existingChat = chats.find(chat => {
          const participantIds = chat.chat?.participants?.map((participant: any) => participant.id) || [];
          console.log("Checking chat participants:", participantIds);
          const matches = participantIds.includes(user.id) && participantIds.includes(selectedUserId);
          if (matches) {
            console.log("✅ Found matching chat in local array!");
          }
          return matches;
        });

        if (existingChat) {
          console.log("✅ Chat found in local array:", existingChat);
        }

        // Step 2: If not found locally, check backend using optimized endpoint
        if (!existingChat) {
          console.log("❌ Chat not found in local array, checking backend...");
          
          // Use the optimized action to check if chat exists between two participants
          const checkResponse: any = await dispatch(checkChatBetweenParticipants({
            userId1: user.id,
            userId2: selectedUserId
          }));

          console.log("Backend check response:", checkResponse);

          if (checkResponse.payload) {
            const response = checkResponse.payload;
            console.log("✅ Found existing chat in backend with selected user:", selectedUserId, response);
            console.log("Chat ID:", response.id, "ContextId:", response.contextId);
            
            // Transform the response to match exactly what fetchParticipantChats creates
            const otherParticipant = response.participants?.find((p: any) => p.id !== user.id);
            existingChat = {
              id: response.contextId, // This matches the transformed structure from fetchParticipantChats
              name: otherParticipant?.firstName || otherParticipant?.name || "Unknown User",
              avatar: otherParticipant?.photo?.path || otherParticipant?.photo?.url || null,
              lastMessage: response.lastMessage || "No messages yet",
              timestamp: formatTimestamp(response.lastMessageAt || new Date().toISOString()),
              unread: response.unreadCount?.[user.id] || 0,
              status: "online",
              pinned: false,
              chat: response // The full chat object
            };
            
            console.log("Transformed chat structure for list:", existingChat);
            console.log("Current chats before adding:", chats.length);
            
            // Simply add the chat to the top of the chat list
            console.log("📌 Adding chat directly to the top of the chat list");
            console.log("📌 Chat to add:", existingChat);
            console.log("📌 Current chats before dispatch:", chats.length);
            
            // Add the chat to local state to ensure it appears in the sidebar
            console.log("📌 Adding chat to local state");
            setLocalChats([existingChat, ...chats]);
            
            console.log("✅ Chat added to local state");
          } else {
            console.log("❌ No existing chat found in backend");
          }
        }

        // Step 3: If chat exists, select it
        if (existingChat) {
          console.log("✅ Selecting chat with user:", selectedUserId);
          dispatch(setSelectedChat(existingChat));
          
          // Fetch conversations for the selected chat if it's from backend
          if (existingChat.chat?.id) {
            console.log("📨 Fetching conversations for chat:", existingChat.chat.id);
            await dispatch(fetchConversations({
              chatId: existingChat.chat.id,
              page: 1,
              limit: CONVERSATION_PAGE_SIZE
            }));
          }
          
          // Mark messages as read for the current user
          if (existingChat.chat?.unreadCount?.[user.id] > 0) {
            const updatedUnreadCount = { ...existingChat.chat.unreadCount };
            updatedUnreadCount[user.id] = 0; // Mark as read

            await dispatch(updateChat({
              chatId: existingChat.chat.id,
              data: {
                ...existingChat.chat,
                contextType: { id: Number(existingChat.chat.contextType?.id || 2) },
                unreadCount: updatedUnreadCount
              }
            }));
          }
          
          // On mobile, close sidebar to show chat
          if (isMobileView) {
            setIsSidebarOpen(false);
          }
          
          // Scroll to the selected chat message
          setTimeout(() => {
            scrollToBottom();
          }, 200);
        } else {
          // Step 4: Chat doesn't exist anywhere, create new chat
          console.log("No existing chat found, creating new chat with user:", selectedUserId);
          
          // Get selected user name from participants or use default
          const selectedUserName = searchParams.get("selectedUserName") || "User";
          
          // Create new chat
          const createChatResponse: any = await dispatch(createProfessionalChat({
            currentUserId: user.id,
            professionalId: selectedUserId,
            professionalName: selectedUserName,
            lastMessage: "Hi"
          }));

          if (createChatResponse.meta.requestStatus === "fulfilled") {
            const newChat = createChatResponse.payload;
            console.log("New chat created successfully:", newChat);

            // Send first message "Hi"
            await handleSendMessage("Hi", newChat, false);

            // Refresh chats to get the newly created chat in the list
            const refreshResponse: any = await dispatch(fetchParticipantChats({ 
              currentUserId: user.id, 
              page: 1, 
              limit: 10 
            }));

            // Find and select the newly created chat
            if (refreshResponse.meta.requestStatus === "fulfilled" && refreshResponse.payload?.chats) {
              const createdChat = refreshResponse.payload.chats.find((chat: any) => {
                const participantIds = chat.chat?.participants?.map((participant: any) => participant.id) || [];
                return participantIds.includes(user.id) && participantIds.includes(selectedUserId);
              });

              if (createdChat) {
                dispatch(setSelectedChat(createdChat));
                
                // Scroll to the selected chat message
                setTimeout(() => {
                  scrollToBottom();
                }, 100);
              }
            }

            // On mobile, close sidebar to show chat
            if (isMobileView) {
              setIsSidebarOpen(false);
            }
          } else {
            console.error("Failed to create chat:", createChatResponse);
            alert(t("messagesAndVideoCall.failedToCreateConversation"));
          }
        }
      } catch (error) {
        console.error("Error handling selected user chat:", error);
        alert(t("messagesAndVideoCall.errorLoadingConversation"));
        selectedUserIdProcessedRef.current = null;
      } finally {
        // Hide loading state
        setShowFullScreenLoader(false);
        
        // Clear URL parameters after handling - use dynamic path based on user role
        const roleId = Number(user?.role?.id);
        let messagePath = "/client/MessageAndVideoCall";
        if (roleId === RoleEnum.professional || roleId === RoleEnum.internationl_professional) {
          messagePath = "/MessageAndVideoCall";
        } else if (roleId === RoleEnum.client) {
          messagePath = "/client/MessageAndVideoCall";
        }
        navigate(messagePath, { replace: true });
      }
    };

    // Execute the async function
    handleSelectedUserChat();
  }, [searchParams, user?.id, dispatch, navigate, chats, isMobileView, scrollToBottom]);

  // Effect to handle professional contact from URL parameters
  useEffect(() => {
    const professionalId = searchParams.get("professionalId");
    const professionalName = searchParams.get("professionalName");
    const offerId = searchParams.get("offerId");
    const userId = searchParams.get("userId");

    console.log("🔄 professionalId effect triggered:", {
      professionalId,
      userId: user?.id,
      isFirstRender: isFirstRenderRef.current,
      chatsLength: chats.length,
      alreadyProcessed: professionalIdProcessedRef.current,
      loading
    });

    // Only process if we have URL parameters
    if (!professionalId || !professionalName || !user?.id) {
      console.log("⏸️ Skipping: No professionalId, professionalName or user.id");
      return;
    }

    // If this is the first render, return early and wait for chats to load
    if (isFirstRenderRef.current) {
      console.log("⏸️ Skipping: First render, waiting for chats to load");
      return;
    }

    // Wait for chats to load before processing
    if (chats.length === 0 && !loading) {
      console.log("⏸️ Skipping: Chats not loaded yet");
      return;
    }

    // If we've already processed this exact professionalId, don't process again
    if (
      professionalIdProcessedRef.current === professionalId ||
      isProcessingUrlRef.current
    ) {
      console.log("⏸️ Skipping: Already processed this professionalId");
      return;
    }

    professionalIdProcessedRef.current = professionalId;
    isProcessingUrlRef.current = true;

    const fetchCurrentOffer = async (offerId: string, professionalId: string, chat = null) => {
      const response = await dispatch(fetchOffer(offerId));
      if (response.meta.requestStatus === "fulfilled") {
        const offer: any = response.payload;
        if (chat) {
          await handleSendMessage(offer?.description, chat.chat, true, offer?.id);
        }
        else {
          createChat({
            currentUserId: Number(user.role?.id) === RoleEnum.professional || Number(user.role?.id) === RoleEnum.internationl_professional ? offer.job.userId.id : user.id,
            professionalId: professionalId,
            professionalName: professionalName,
            offerId: offerId || null,
            lastMessage: offer?.description || ""
          });
        }
      }
    };

    // Async function to handle chat search and creation
    const handleProfessionalChat = async () => {
      let processedSuccessfully = false;
      try {
        // Show loading state
        setShowFullScreenLoader(true);
        
        console.log("🔍 Looking for chat with professional:", professionalId);
        console.log("📋 Total chats loaded:", chats.length);
        
        // Determine current user ID based on role
        const currentUserId = Number(user.role?.id) === RoleEnum.professional || Number(user.role?.id) === RoleEnum.internationl_professional ? (userId || user.id) : user.id;
        
        // Step 1: Check if chat already exists in local chats array
        let existingChat = chats.find(chat => {
          const participantIds = chat.chat?.participants?.map((participant: any) => participant.id) || [];
          console.log("Checking chat participants:", participantIds);
          const matches = participantIds.includes(currentUserId) && participantIds.includes(professionalId);
          if (matches) {
            console.log("✅ Found matching chat in local array!");
          }
          return matches;
        });

        if (existingChat) {
          console.log("✅ Chat found in local array:", existingChat);
        }

        // Step 2: If not found locally, check backend using optimized endpoint
        if (!existingChat) {
          console.log("❌ Chat not found in local array, checking backend...");
          
          // Use the optimized action to check if chat exists between two participants
          const checkResponse: any = await dispatch(checkChatBetweenParticipants({
            userId1: currentUserId,
            userId2: professionalId
          }));

          console.log("Backend check response:", checkResponse);

          if (checkResponse.payload) {
            const response = checkResponse.payload;
            console.log("✅ Found existing chat in backend with professional:", professionalId, response);
            console.log("Chat ID:", response.id, "ContextId:", response.contextId);
            
            // Transform the response to match exactly what fetchParticipantChats creates
            const otherParticipant = response.participants?.find((p: any) => p.id !== user.id);
            existingChat = {
              id: response.contextId,
              name: otherParticipant?.firstName || otherParticipant?.name || "Unknown User",
              avatar: otherParticipant?.photo?.path || otherParticipant?.photo?.url || null,
              lastMessage: response.lastMessage || "No messages yet",
              timestamp: formatTimestamp(response.lastMessageAt || new Date().toISOString()),
              unread: response.unreadCount?.[user.id] || 0,
              status: "online",
              pinned: false,
              chat: response
            };
            
            console.log("Transformed chat structure for list:", existingChat);
          } else {
            console.log("❌ No existing chat found in backend");
          }
        }

        // Step 3: If chat exists, select it
        if (existingChat) {
          console.log("✅ Selecting chat with professional:", professionalId);
          dispatch(setSelectedChat(existingChat));
          
          // Fetch conversations for the selected chat if it's from backend
          if (existingChat.chat?.id) {
            console.log("📨 Fetching conversations for chat:", existingChat.chat.id);
            await dispatch(fetchConversations({
              chatId: existingChat.chat.id,
              page: 1,
              limit: CONVERSATION_PAGE_SIZE
            }));
          }
          
          // Mark messages as read for the current user
          if (existingChat.chat?.unreadCount?.[user.id] > 0) {
            const updatedUnreadCount = { ...existingChat.chat.unreadCount };
            updatedUnreadCount[user.id] = 0;

            await dispatch(updateChat({
              chatId: existingChat.chat.id,
              data: {
                ...existingChat.chat,
                contextType: { id: Number(existingChat.chat.contextType?.id || 2) },
                unreadCount: updatedUnreadCount
              }
            }));
          }
          
          // Handle offer if provided
          if (offerId) {
            await fetchCurrentOffer(offerId, professionalId, existingChat);
          }
          
          // On mobile, close sidebar to show chat
          if (isMobileView) {
            setIsSidebarOpen(false);
          }
          
          // Scroll to the selected chat message
          setTimeout(() => {
            scrollToBottom();
          }, 200);
          processedSuccessfully = true;
        } else {
          // Step 4: Chat doesn't exist anywhere, create new chat
          console.log("No existing chat found, creating new chat with professional:", professionalId);
          
          if (offerId) {
            await fetchCurrentOffer(offerId, professionalId);
            processedSuccessfully = true;
          } else {
            createChat({
              currentUserId: currentUserId,
              professionalId: professionalId,
              professionalName: professionalName,
            });
            processedSuccessfully = true;
          }
        }
      } catch (error) {
        console.error("Error handling professional chat:", error);
        alert(t("messagesAndVideoCall.errorLoadingConversation"));
        professionalIdProcessedRef.current = null;
      } finally {
        // Hide loading state
        setShowFullScreenLoader(false);
        isProcessingUrlRef.current = false;
        if (!processedSuccessfully) {
          professionalIdProcessedRef.current = null;
        }

        // Clear URL parameters after handling - use dynamic path based on user role
        const roleId = Number(user?.role?.id);
        let messagePath = "/client/MessageAndVideoCall";
        if (roleId === RoleEnum.professional || roleId === RoleEnum.internationl_professional) {
          messagePath = "/MessageAndVideoCall";
        } else if (roleId === RoleEnum.client) {
          messagePath = "/client/MessageAndVideoCall";
        }
        navigate(messagePath, { replace: true });
      }
    };

    // Execute the async function
    handleProfessionalChat();
  }, [searchParams, user?.id, dispatch, navigate, chats, loading, isMobileView, scrollToBottom]);

  const createChat = (arg) => {
    dispatch(createProfessionalChat(arg)).then(async (result) => {
      if (result.meta.requestStatus === "fulfilled") {
        // Chat created successfully, fetch conversations
        const newChat = result.payload;
        // await dispatch(fetchConversations(newChat.id));
        if (arg.offerId) {
          await handleSendMessage(arg.lastMessage, newChat, true, arg.offerId);
        }
      }
    });
  };



  // Local search functionality - no API calls
  const filteredChats = React.useMemo(() => {
    const chatsToUse = localChats.length > 0 ? localChats : chats;
    const sortedChats = [...chatsToUse];

    // Sort chats by lastMessageAt timestamp (most recent first)
    sortedChats.sort((a, b) => {
      const aTime = new Date(a.chat?.lastMessageAt || 0).getTime();
      const bTime = new Date(b.chat?.lastMessageAt || 0).getTime();
      return bTime - aTime;
    });

    // If we have localChats, ensure the first chat (the one we added) stays at the top
    if (localChats.length > 0) {
      // Move the first chat to the top regardless of timestamp
      const firstChat = sortedChats.shift();
      if (firstChat) {
        sortedChats.unshift(firstChat);
      }
    }

    if (!searchQuery.trim()) {
      return sortedChats;
    }

    const query = searchQuery.toLowerCase();
    return sortedChats.filter(chat =>
      chat.name.toLowerCase().includes(query) ||
      (chat.lastMessage || chat.chat?.lastMessage || "").toLowerCase().includes(query)
    );
  }, [chats, localChats, searchQuery, chatListKey]);

  // Helper to get display name: other participant (not current user) whose role is not 1 (admin)
  const getChatDisplayName = (chatItem: any): string => {
    const participants = chatItem?.chat?.participants || chatItem?.participants || [];
    if (participants && participants.length > 0) {
      const other = participants.find((p: any) => {
        const roleId = (p?.role && (p.role.id || p.role)) || p?.roleId;
        return p?.id !== user?.id && Number(roleId) !== 1;
      }) || participants.find((p: any) => p?.id !== user?.id);
      if (other) {
        const name = other.name || (other.firstName && other.lastName ? `${other.firstName} ${other.lastName}` : other.firstName) || other.email;
        if (name) return name;
      }
    }
    return chatItem?.name || "Conversation";
  };

  const handleSendMessage = async (overrideText?: string, chatArg?: any, isQuote?: boolean, referenceId?: string) => {
    const textToSend = (overrideText !== undefined ? overrideText : message).trim();
    const chat = chatArg !== undefined ? chatArg : selectedChat.chat;
    
    if ((!textToSend && selectedFiles.length === 0) || !chat || !user?.id || isSendingMessage) {
      return;
    }

    // Check if chat is blocked
    if (chat.status && Number(chat.status.id) === ChatStatusEnum.blocked) {
      GlobalService.showToast(
        "error",
        t("messagesAndVideoCall.chatBlocked"),
        t("messagesAndVideoCall.chatBlockedMessage")
      );
      return;
    }

    // Check communication restrictions if user is a professional
    const userRoleId = Number(user?.role?.id);
    const isProfessional = userRoleId === RoleEnum.professional || userRoleId === RoleEnum.internationl_professional;
    
    if (isProfessional) {
      // Find the other participant (client) from chat participants
      let otherParticipantId = null;
      const participants = chat.participants || [];
      
      if (participants && Array.isArray(participants) && participants.length > 0) {
        const otherParticipant = participants.find((p: any) => p.id !== user?.id);
        otherParticipantId = otherParticipant?.id;
      }
      
      if (otherParticipantId) {
        try {
          const commCheck: any = await dispatch(checkCanCommunicate({ 
            professionalId: user.id, 
            clientId: otherParticipantId 
          })).unwrap();
          
          if (!commCheck.canCommunicate) {
            const suspensionEndDate = commCheck.suspensionEndDate 
              ? new Date(commCheck.suspensionEndDate).toLocaleDateString() 
              : "unknown date";
            
            if (commCheck.suspensionType === "new_clients_only") {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedNewClientsMessage", { date: suspensionEndDate })
              );
            } else {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedMessagingMessage", { date: suspensionEndDate })
              );
            }
            return;
          }
        } catch (error) {
          // Block communication if API check fails to be safe
          GlobalService.showToast(
            "error", 
            t("messagesAndVideoCall.unableToVerify"), 
            t("messagesAndVideoCall.tryAgainOrContact")
          );
          return;
        }
      }
    }

      // Validate message against chat rules (skip validation for quote messages)
    if (!isQuote && textToSend) {
      // Check contract context for contract-based rule enforcement
      const chatParticipants = chat.participants?.map(p => p.id) || [];
      const contractContext = checkContractContext(user.id, chatParticipants, contracts);
      
      const validationResult = validateMessage(
        {
          message: textToSend,
          attachments: uploadedFiles,
          senderId: user.id,
          roleId: Number(user.role?.id),
          chatId: chat.id
        },
        chatRules,
        contractContext
      );

      // If validation fails, separate violations by severity
      if (!validationResult.isValid) {
        // Define critical rule types that should block messages
        // These rules will prevent the message from being sent
        const criticalRuleTypes = [
          ChatRuleTypeEnum.No_Contact_Information,        // Contact info sharing
          ChatRuleTypeEnum.Sensitive_Content_Filter,      // Prohibited content
          ChatRuleTypeEnum.External_Deal_Detection,       // External transaction attempts
          ChatRuleTypeEnum.External_Platform_Links,       // External links (BLOCKING)
          ChatRuleTypeEnum.Spam_and_Repetitive_Messages_Filter, // Spam/flooding
          ChatRuleTypeEnum.Chat_Message_Limit,            // Rate limiting
          ChatRuleTypeEnum.File_Attachment_Filter         // Blocked file types
        ];

        // Define warning rule types that log but allow message
        // These rules will flag the message for admin review but not block it
        const warningRuleTypes = [
          ChatRuleTypeEnum.Professional_Language,         // Unprofessional language
          ChatRuleTypeEnum.Role_Based_Contextual_Rules    // Role-specific violations
        ];

        // Separate critical violations from warnings
        const criticalViolations = validationResult.violatedRules.filter(v => 
          criticalRuleTypes.includes(Number(v.ruleType) as ChatRuleTypeEnum)
        );

        const warningViolations = validationResult.violatedRules.filter(v => 
          warningRuleTypes.includes(Number(v.ruleType) as ChatRuleTypeEnum)
        );

        // For critical violations, show error and block message
        if (criticalViolations.length > 0) {
          // Create logs for critical violations (without conversation reference since message is blocked)
          for (const violation of criticalViolations) {
            try {
              const logData: ChatRuleLogCreateDto = {
                conversation: null, // No conversation since message is blocked
                chatRule: violation.rule,
                user: {
                  id: user.id,
                  firstName: user.firstName || "",
                  lastName: user.lastName || ""
                }
              };
              
              // Create the log asynchronously
              dispatch(createChatRuleLog(logData));
            } catch (logError) {
              console.error("Failed to create chat rule log:", logError);
            }
          }
          
          const violationMessages = criticalViolations.map(v => {
            // Format violation message based on rule type
            switch (Number(v.ruleType)) {
              case ChatRuleTypeEnum.No_Contact_Information:
                return t("messagesAndVideoCall.violationContactInfo") || "Messages cannot contain phone numbers, emails, or external contact information";
              case ChatRuleTypeEnum.Sensitive_Content_Filter:
                return t("messagesAndVideoCall.violationSensitiveContent") || "Message contains prohibited or sensitive content";
              case ChatRuleTypeEnum.External_Deal_Detection:
                return t("messagesAndVideoCall.violationExternalDeal") || "Messages suggesting external transactions are not allowed";
              case ChatRuleTypeEnum.External_Platform_Links:
                return t("messagesAndVideoCall.violationExternalLinks") || "External links are not allowed. Please keep all communications within the platform";
              case ChatRuleTypeEnum.Spam_and_Repetitive_Messages_Filter:
                return t("messagesAndVideoCall.violationSpam") || "Too many messages sent in rapid succession or repetitive content detected";
              case ChatRuleTypeEnum.Chat_Message_Limit:
                return t("messagesAndVideoCall.violationMessageLimit") || "Message rate limit exceeded. Please wait before sending more messages";
              case ChatRuleTypeEnum.File_Attachment_Filter:
                return t("messagesAndVideoCall.violationFileType") || "Blocked file types detected. Executable and potentially harmful files are not allowed";
              default:
                return v.details;
            }
          }).join("\n");
          
          GlobalService.showToast(
            "error",
            t("messagesAndVideoCall.messageBlocked"),
            violationMessages
          );
          return; // Block the message
        }

        // For warning violations, show warning but allow message to send
        // These will still be logged for admin review
        if (warningViolations.length > 0) {
          const warningMessages = warningViolations.map(v => {
            switch (Number(v.ruleType)) {
              case ChatRuleTypeEnum.Professional_Language:
                return t("messagesAndVideoCall.warningProfessionalLanguage") || "Please maintain professional language in communications";
              case ChatRuleTypeEnum.Role_Based_Contextual_Rules:
                return t("messagesAndVideoCall.warningRoleViolation") || "Your message may violate platform communication guidelines";
              default:
                return v.details;
            }
          }).join("\n");
          
          GlobalService.showToast(
            "warning",
            t("messagesAndVideoCall.contentWarning"),
            warningMessages
          );
        }
      }
    }

    // Set sending state to prevent multiple simultaneous sends
    setIsSendingMessage(true);

    // Store original message and files for potential restoration
    const originalMessage = message;
    const originalFiles = [...selectedFiles];

    // Clear input immediately after function call but before API request
    setMessage("");
    setSelectedFiles([]);
    dispatch(clearUploadedFiles());
    dispatch(clearReplyToMessage());

    // Reset textarea height to 1 line after sending message
    setTimeout(() => {
      const textareas = document.querySelectorAll("textarea[placeholder=\"Type a message...\"]");
      textareas.forEach((textarea) => {
        const target = textarea as HTMLTextAreaElement;
        target.style.height = "auto";
        target.style.height = "44px"; // Reset to single line height
      });
    }, 10);

    // Stop typing indicator immediately
    if (isCurrentlyTyping) {
      handleTyping(false);
    }

    // Get chat participants for WebSocket notification
    const chatParticipants = chat.participants?.map((p: any) => p.id) || [];
    
    try {
      // Send conversation and wait for completion
      const result = await dispatch(sendConversation({
        message: textToSend,
        chatId: chat.id,
        currentUserId: user.id,
        attachments: uploadedFiles,
        type: isQuote ? ConversationTypeEnum.Quote : ConversationTypeEnum.Text,
        referenceId: isQuote && referenceId ? String(referenceId) : undefined,
        chatParticipants: chatParticipants,
        replyTo: replyToMessage ? {
          id: replyToMessage.messageId
        } : undefined,
        isReply: !!replyToMessage
      }));

      // Check if the conversation was sent successfully
      if (result.meta.requestStatus === "fulfilled") {
        
        // Track home visit on 3rd TOTAL message in the conversation (from professional OR client)
        try {
          if (selectedChat?.chat) {
            // Count TOTAL messages (from both participants) in THIS SPECIFIC conversation
            const currentChatId = selectedChat.chat.id || chat.id;
            
            // Filter conversations for THIS chat only
            const conversationsInThisChat = conversations.filter(conv => 
              conv.chatId?.id === currentChatId || conv.chatId === currentChatId
            );
            
            // Total messages in this conversation (from both professional and client)
            const totalMessages = conversationsInThisChat.length;
            
            // Track home visit on the 3rd message (when totalMessages = 2, the next message will be 3rd)
            if (totalMessages === 2) {
              // Find the professional participant in the chat
              const participants = chat.participants || selectedChat.chat.participants || [];
              const professionalParticipant = participants.find((p: any) => {
                const roleId = Number(p?.role?.id);
                return roleId === RoleEnum.professional || roleId === RoleEnum.internationl_professional;
              });
              
              // Find the client participant
              const clientParticipant = participants.find((p: any) => {
                const roleId = Number(p?.role?.id);
                return roleId === RoleEnum.client || roleId === RoleEnum.internationl_client;
              });
              
              // Track if we have both professional and client in this conversation
              if (professionalParticipant?.id && clientParticipant?.id) {
                await dispatch(trackActivity({
                  professionalId: professionalParticipant.id,
                  activityType: "home_visit",
                  clientId: clientParticipant.id,
                  metadata: {
                    professionalType: "home_service",
                    chatId: chat.id,
                    totalMessages: totalMessages + 1 // This will be the 3rd message
                  }
                }));
              }
            }
          }
        } catch (error) {
          console.error("Error tracking home visit:", error);
        }

        // Log warning violations WITH conversation reference (since message was sent)
        // Note: Critical violations are already logged WITHOUT conversation reference before message is blocked
        // This section only runs for warning violations since critical violations return early
        if (!isQuote && textToSend) {
          // Check contract context again for logging
          const chatParticipants = chat.participants?.map(p => p.id) || [];
          const contractContext = checkContractContext(user.id, chatParticipants, contracts);
          
          const validationResult = validateMessage(
            {
              message: textToSend,
              attachments: uploadedFiles,
              senderId: user.id,
              roleId: Number(user.role?.id),
              chatId: chat.id
            },
            chatRules,
            contractContext
          );

          if (!validationResult.isValid && result.payload) {
            // Create logs for warning violations with conversation reference
            const conversationPayload = result.payload as any;
            for (const violation of validationResult.violatedRules) {
              try {
                const logData: ChatRuleLogCreateDto = {
                  conversation: {
                    id: conversationPayload.id,
                    message: textToSend
                  },
                  chatRule: violation.rule,
                  user: {
                    id: user.id,
                    firstName: user.firstName || "",
                    lastName: user.lastName || ""
                  }
                };
                
                // Create log with conversation reference for admin review
                dispatch(createChatRuleLog(logData));
              } catch (logError) {
                console.error("Failed to create chat rule log with conversation:", logError);
              }
            }
          }
        }

        // Update chat with new message info, but don't change current user's unread count
        // The current user's unread count should remain 0 since they just sent the message
        const updatedUnreadCount = { ...chat.unreadCount };

        // Set current user's unread count to 0 (they've read their own message)
        updatedUnreadCount[user.id] = 0;

        // Increment unread count for other participants
        chat.participants?.forEach((participant: any) => {
          if (participant.id !== user.id) {
            updatedUnreadCount[participant.id] = (updatedUnreadCount[participant.id] || 0) + 1;
          }
        });

        // Update the chat with new message info
        const updatedChat = {
          ...chat,
          contextType: { id: Number(chat.contextType.id) },
          lastMessage: textToSend,
          lastMessageAt: new Date().toISOString(),
          unreadCount: updatedUnreadCount,
        };
        
        await dispatch(updateChat({
          chatId: chat.id,
          data: updatedChat
        }));

        // Scroll to bottom after sending message
        setTimeout(() => {
          scrollToBottom();
        }, 100);

      } else {
        // Restore message and files if API request failed
        setMessage(originalMessage);
        setSelectedFiles(originalFiles);
        alert(t("messagesAndVideoCall.failedToSendMessage"));
      }
    } catch (error) {
      // Restore message and files if API request failed
      setMessage(originalMessage);
      setSelectedFiles(originalFiles);
      alert(t("messagesAndVideoCall.failedToSendMessage"));
    } finally {
      // Reset sending state
      setIsSendingMessage(false);
    }
  };

  const handleStartCall = async (type: CallType = CallType.VIDEO) => {
    if (!selectedChat) {
      alert(t("messagesAndVideoCall.selectChatFirst"));
      return;
    }

    // Check if chat is blocked
    if (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) {
      GlobalService.showToast(
        "error",
        t("messagesAndVideoCall.chatBlocked"),
        t("messagesAndVideoCall.chatBlockedCalls")
      );
      return;
    }

    // Check profile and verification requirements first
    if (!checkRequirements()) {
      return; // Stop execution if requirements not met
    }

    // Check communication restrictions if user is a professional
    const userRoleId = Number(user?.role?.id);
    const isProfessional = userRoleId === RoleEnum.professional || userRoleId === RoleEnum.internationl_professional;
    
    if (isProfessional) {
      // Find the other participant (client) from chat participants - anyone who is NOT the current user
      let otherParticipantId = null;
      if (selectedChat.chat?.participants && Array.isArray(selectedChat.chat.participants)) {
        const otherParticipant = selectedChat.chat.participants.find((p: any) => p.id !== user?.id);
        otherParticipantId = otherParticipant?.id;
      }
      
      if (otherParticipantId) {
        try {
          const commCheck: any = await dispatch(checkCanCommunicate({ 
            professionalId: user.id, 
            clientId: otherParticipantId 
          })).unwrap();
          
          if (!commCheck.canCommunicate) {
            const suspensionEndDate = commCheck.suspensionEndDate 
              ? new Date(commCheck.suspensionEndDate).toLocaleDateString() 
              : "unknown date";
            
            if (commCheck.suspensionType === "new_clients_only") {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedNewClientsCall", { date: suspensionEndDate })
              );
            } else {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedCallsMessage", { date: suspensionEndDate })
              );
            }
            return;
          }
        } catch (error) {
          console.error("Error checking suspension for call:", error);
          // Block call if API check fails to be safe
          GlobalService.showToast(
            "error", 
            t("messagesAndVideoCall.unableToVerify"), 
            t("messagesAndVideoCall.tryAgainOrContact")
          );
          return;
        }
      }
    }

    // Get chat participants (excluding current user)
    const participants = selectedChat.chat?.participants || [];

    if (participants.length === 0) {
      alert(t("messagesAndVideoCall.noParticipants"));
      return;
    }

    const participantIds = participants
      .map((p: any) => p.id)
      .filter(Boolean)
      .filter((id: string) => id !== user?.id); // Exclude current user

    if (participantIds.length === 0) {
      alert(t("messagesAndVideoCall.noOtherParticipants"));
      return;
    }



    // Use call management system to initiate call
    const callTypeString = type === CallType.VIDEO ? "video" : "audio";
    setCallType(type);

    // Reset the explicit leave flag when starting a new call
    setHasExplicitlyLeftCall(false);

    const call = await initiateCall(callTypeString, participantIds);

    if (call) {
      // Store call ID and reset join tracking
      setCurrentCallId(call.id);
      setHasAnyoneJoinedCall(false);

      // Send call_started conversation message
      try {
        const callStartedMessage = `${callType === CallType.VIDEO ? "Video" : "Audio"} call started`;
        await dispatch(sendConversation({
          message: callStartedMessage,
          chatId: selectedChat.chat.id,
          currentUserId: user.id,
          attachments: [],
          type: ConversationTypeEnum.call_started,
          chatParticipants: selectedChat.chat?.participants?.map((p: any) => p.id) || [],
        }));
      } catch (error) {
        console.error("Failed to send call_started message:", error);
      }

      // Send WebSocket notification to other participants about call initiation
      try {
        const chatParticipants = selectedChat.chat?.participants?.map((p: any) => p.id) || [];
        const otherParticipants = chatParticipants.filter(id => id !== user?.id);

        if (otherParticipants.length > 0) {
          await sendWebSocketMessage({
            receivers: otherParticipants,
            sender: user?.id || "",
            type: "call_initiated",
            detail: {
              callId: call.id,
              chatId: selectedChat.chat?.id,
              callType: call.callType,
              initiatedBy: user?.id,
              channelName: call.channelName,
              participantIds: chatParticipants,
              timestamp: new Date().toISOString(),
              initiator: {
                id: user?.id,
                name: user?.firstName || user?.email || "Unknown User2",
                firstName: user?.firstName || "Unknown"
              },
              participants: chatParticipants.map(id => {
                // Find the participant data from the chat
                const participantData = selectedChat.chat?.participants?.find((p: any) => p.id === id) as any;
                return {
                  id: `${call.id}-${id}`, // Unique participant ID
                  userId: id,
                  status: id === user?.id ? "connected" : "invited",
                  isAudioEnabled: true,
                  isVideoEnabled: true,
                  user: {
                    id: id,
                    name: participantData?.name || participantData?.firstName || "Unknown User3",
                    firstName: participantData?.firstName || "Unknown",
                    lastName: participantData?.lastName || "",
                    avatar: participantData?.photo?.path || participantData?.photo?.url || null
                  }
                };
              })
            }
          });
        }
      } catch (error) {
        console.error("Failed to send call initiation notification:", error);
      }

      if (isMobileView) {
        setIsSidebarOpen(false);
      }
    } else {
      alert(t("messagesAndVideoCall.failedToStartCall"));
    }
  };

  const handleLeaveCall = async () => {
    if (currentCall) {
      // Leave call - show the banner for current user
      setHasExplicitlyLeftCall(false);
      await leaveCall("User left the call");

      // Send WebSocket notification to other participants about user leaving
      try {
        const chatParticipants = selectedChat?.chat?.participants?.map((p: any) => p.id) || [];
        const otherParticipants = chatParticipants.filter(id => id !== user?.id);

        if (otherParticipants.length > 0) {
          await sendWebSocketMessage({
            receivers: otherParticipants,
            sender: user?.id || "",
            type: "user_left_call",
            detail: {
              callId: currentCall.id,
              chatId: selectedChat?.chat?.id,
              leftBy: user?.id,
              timestamp: new Date().toISOString()
            }
          });
        }
      } catch (error) {
        console.error("Failed to send user left call notification:", error);
      }
    }

    setIsInCall(false);
    setIsMuted(false);
    setIsVideoOff(false);
    setChannelName("");
  };

  const handleEndCall = async () => {
    if (currentCall) {
      // Check if no one joined the call and send missed_call message
      if (!hasAnyoneJoinedCall) {
        try {
          const missedCallMessage = `Missed ${callType === CallType.VIDEO ? "video" : "audio"} call`;
          await dispatch(sendConversation({
            message: missedCallMessage,
            chatId: selectedChat?.chat?.id || "",
            currentUserId: user?.id || "",
            attachments: [],
            type: ConversationTypeEnum.missed_call,
            chatParticipants: selectedChat?.chat?.participants?.map((p: any) => p.id) || [],
          }));
        } catch (error) {
          console.error("Failed to send missed_call message:", error);
        }
      }

      // End call - hide the banner for current user
      setHasExplicitlyLeftCall(true);
      await endCall("Call ended by initiator");

      // Send WebSocket notification to other participants about call ending
      try {
        const chatParticipants = selectedChat?.chat?.participants?.map((p: any) => p.id) || [];
        const otherParticipants = chatParticipants.filter(id => id !== user?.id);

        if (otherParticipants.length > 0) {
          await sendWebSocketMessage({
            receivers: otherParticipants,
            sender: user?.id || "",
            type: "call_ended",
            detail: {
              callId: currentCall.id,
              chatId: selectedChat?.chat?.id,
              endedBy: user?.id,
              timestamp: new Date().toISOString()
            }
          });
        }
      } catch (error) {
        console.error("Failed to send call ended notification:", error);
      }

      // Reset call tracking states
      setCurrentCallId(null);
      setHasAnyoneJoinedCall(false);
    }

    setIsInCall(false);
    setIsMuted(false);
    setIsVideoOff(false);
    setChannelName("");
  };

  // Handle joining an existing call
  const handleJoinExistingCall = async (call: any) => {
    // Check camera access permission before joining
    if (!checkCameraAccess()) {
      return; // Stop execution if camera access is denied
    }

    // Reset the explicit leave flag when joining a call
    setHasExplicitlyLeftCall(false);

    const success = await joinManagedCall(call);
    if (success) {
      setCallType(call.callType === "video" ? CallType.VIDEO : CallType.AUDIO);

      // Send WebSocket notification that user has joined the call
      try {
        const chatParticipants = selectedChat?.chat?.participants?.map((p: any) => p.id) || [];
        const otherParticipants = chatParticipants.filter(id => id !== user?.id);

        if (otherParticipants.length > 0) {
          await sendWebSocketMessage({
            receivers: otherParticipants,
            sender: user?.id || "",
            type: "user_joined_call",
            detail: {
              callId: call.id,
              chatId: selectedChat?.chat?.id,
              joinedBy: user?.id,
              timestamp: new Date().toISOString()
            }
          });
        }
      } catch (error) {
        console.error("Failed to send user joined call notification:", error);
      }

      if (isMobileView) {
        setIsSidebarOpen(false);
      }
    } else {
      // Remove the call from local active calls if join failed (call might have ended)
      setLocalActiveCalls(prev => prev.filter(c => c.id !== call.id));
      alert(t("messagesAndVideoCall.callAlreadyEnded"));
    }
  };

  const handleChatSelect = (chat: any) => {
    dispatch(setSelectedChat(chat));
    if (chat?.chat?.id) {
      dispatch(fetchConversations({
        chatId: chat.chat.id,
        page: 1,
        limit: CONVERSATION_PAGE_SIZE
      }));
    }

    // Mark messages as read for the current user when selecting a chat
    if (chat.chat?.unreadCount?.[user?.id] > 0) {
      const updatedUnreadCount = { ...chat.chat.unreadCount };
      updatedUnreadCount[user.id] = 0; // Mark as read

      dispatch(updateChat({
        chatId: chat.chat.id,
        data: {
          ...chat.chat,
          contextType: { id: Number(chat.chat.contextType.id) },
          unreadCount: updatedUnreadCount
        }
      }));
    }

    // Reset explicit leave flag when switching chats
    setHasExplicitlyLeftCall(false);

    // Clear typing indicators when switching chats
    setTypingUsers([]);
    setIsCurrentlyTyping(false);

    // Clear call banners when switching chats
    setLocalActiveCalls([]);
    setHasExplicitlyLeftCall(false);

    // Clear any pending typing timeouts
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // No need to join/leave chat rooms in user-based approach
    // Messages are automatically delivered to all participants

    if (isMobileView) {
      setIsSidebarOpen(false);
    }
  };

  // Helper function to get unread count for current user
  const getCurrentUserUnreadCount = (chat: any): number => {
    if (!chat?.chat?.unreadCount || !user?.id) return 0;
    return chat.chat.unreadCount[user.id] || 0;
  };

  // Helper function to format timestamp (show date and time)
  const formatTimestamp = (timestamp: string): string => {
    if (!timestamp) return "";

    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);
    const timePart = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });

    if (diffInHours < 24) {
      return timePart;
    } else if (diffInHours < 48) {
      return `Yesterday, ${timePart}`;
    } else {
      const datePart = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      });
      return `${datePart}, ${timePart}`;
    }
  };

  const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setSelectedFiles(prev => [...prev, ...files]);

    // Upload each file immediately with progress tracking
    for (const file of files) {
      const fileId = `${file.name}-${file.size}-${Date.now()}`;

      // Add to uploading files set
      setUploadingFiles(prev => new Set(Array.from(prev).concat(fileId)));
      setUploadProgress(prev => ({ ...prev, [fileId]: 0 }));

      try {
        // Simulate progress updates (you can replace this with actual progress tracking if your API supports it)
        const progressInterval = setInterval(() => {
          setUploadProgress(prev => {
            const currentProgress = prev[fileId] || 0;
            if (currentProgress < 90) {
              return { ...prev, [fileId]: currentProgress + Math.random() * 20 };
            }
            return prev;
          });
        }, 200);

        await dispatch(uploadChatFile({ file, shouldShowLoader: false })).unwrap();

        // Complete the progress
        clearInterval(progressInterval);
        setUploadProgress(prev => ({ ...prev, [fileId]: 100 }));

        // Remove from uploading files after a short delay
        setTimeout(() => {
          setUploadingFiles(prev => {
            const newSet = new Set(Array.from(prev));
            newSet.delete(fileId);
            return newSet;
          });
          setUploadProgress(prev => {
            const newProgress = { ...prev };
            delete newProgress[fileId];
            return newProgress;
          });
        }, 500);

      } catch (error) {
        console.error("Failed to upload file:", file.name, error);
        // Remove from uploading files on error
        setUploadingFiles(prev => {
          const newSet = new Set(Array.from(prev));
          newSet.delete(fileId);
          return newSet;
        });
        setUploadProgress(prev => {
          const newProgress = { ...prev };
          delete newProgress[fileId];
          return newProgress;
        });
      }
    }
  };

  const removeFile = (index: number) => {
    const fileToRemove = selectedFiles[index];
    if (fileToRemove) {
      const fileId = `${fileToRemove.name}-${fileToRemove.size}-${Date.now()}`;
      // Clean up upload progress state
      setUploadingFiles(prev => {
        const newSet = new Set(Array.from(prev));
        newSet.delete(fileId);
        return newSet;
      });
      setUploadProgress(prev => {
        const newProgress = { ...prev };
        delete newProgress[fileId];
        return newProgress;
      });
    }

    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    // Also remove from uploadedFiles if it exists
    if (uploadedFiles[index]) {
      dispatch(removeUploadedFile(index));
    }
  };

  // Handle typing indicator with WebSocket
  const handleTyping = useCallback(async (isTyping: boolean) => {
    if (!selectedChat?.chat?.id || !user?.id || !isWebSocketConnected) {
      return;
    }

    // Always update the state and send typing status
    setIsCurrentlyTyping(isTyping);

    try {
      const chatParticipants = selectedChat.chat?.participants?.map((p: any) => p.id) || [];
      const otherParticipants = chatParticipants.filter(id => id !== user?.id);

      if (otherParticipants.length > 0) {
        await sendWebSocketMessage({
          receivers: otherParticipants,
          sender: user?.id,
          type: "typing",
          detail: {
            chatId: selectedChat.chat.id,
            userId: user?.id,
            userName: user?.firstName || user?.email || "Unknown User",
            isTyping: isTyping,
            timestamp: new Date().toISOString()
          }
        });
      }
    } catch (error) {
      console.error("Failed to send typing status:", error);
    }
  }, [selectedChat?.chat?.id, user?.id, isWebSocketConnected, sendWebSocketMessage]);

  // Handle input change with typing indicator
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setMessage(value);

    // Clear existing stop typing timeout
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    if (value.trim()) {
      // Start typing if not already typing
      if (!isCurrentlyTyping) {
        handleTyping(true);
      }

      // Set timeout to stop typing after 2 seconds of no input
      typingTimeoutRef.current = setTimeout(() => {
        handleTyping(false);
      }, 2000);
    } else {
      // If input is empty, stop typing immediately
      if (isCurrentlyTyping) {
        handleTyping(false);
      }
    }
  }, [isCurrentlyTyping, handleTyping]);

  const handleBackToList = () => {
    if (isMobileView) {
      // No need to leave chat room in user-based approach
      dispatch(setSelectedChat(null));
      dispatch(clearMessages());
      dispatch(clearMessages());
      dispatch(clearConversations());
      dispatch(clearUploadedFiles());
      setSelectedFiles([]);
      setIsSidebarOpen(true);
    }
  };

  // Pagination functions
  const handleNextPage = () => {
    if (user?.id && pagination.hasNextPage && !loading) {
      dispatch(fetchParticipantChats({
        currentUserId: user.id,
        page: pagination.currentPage + 1,
        limit: 10
      }));
    }
  };

  const handlePreviousPage = () => {
    if (user?.id && pagination.hasPreviousPage && !loading) {
      dispatch(fetchParticipantChats({
        currentUserId: user.id,
        page: pagination.currentPage - 1,
        limit: 10
      }));
    }
  };

  // Check if user needs to complete profile
  const checkProfileCompletion = () => {
    if (user && !user.phone) {
      setShowProfileCompletionDialog(true);
      return false; // Profile incomplete
    }
    return true; // Profile complete
  };

  // Track when verification data has loaded
  useEffect(() => {
    if (verificationData !== null && verificationData !== undefined) {
      setVerificationDataLoaded(true);
    }
  }, [verificationData]);

  // Check if user needs verification
  const checkVerification = () => {
    // Don't check verification if data hasn't loaded yet
    if (!verificationDataLoaded) {
      return true; // Allow action to proceed while loading
    }
    
    if (!isVerified()) {
      setShowVerificationDialog(true);
      return false; // Verification incomplete
    }
    return true; // Verification complete
  };

  // Check camera access permission
  const checkCameraAccess = () => {
    // If cameraPermission is not available or is true, allow access
    if (user?.cameraPermission === undefined || user?.cameraPermission === null || user?.cameraPermission === true) {
      return true;
    }
    
    // If cameraPermission is explicitly false, deny access
    if (user?.cameraPermission === false) {
      GlobalService.showToast("error", t("messagesAndVideoCall.accessDenied"), t("messagesAndVideoCall.noCameraPermission"));
      return false;
    }
    
    return true;
  };

  // Check if camera access is disabled (for UI disabling)
  const isCameraAccessDisabled = () => {
    return user?.cameraPermission === false;
  };

  // Check both profile and verification
  const checkRequirements = () => {
    // Check camera access first
    if (!checkCameraAccess()) {
      return false;
    }
    
    // Don't block actions if verification data is still loading
    if (!verificationDataLoaded) {
      // Only check profile completion while verification loads
      if (!checkProfileCompletion()) {
        return false;
      }
      return true;
    }
    
    // Check verification first (higher priority)
    // if (!checkVerification()) {
    //   return false;
    // }
    
    // Then check profile completion
    if (!checkProfileCompletion()) {
      return false;
    }
    
    return true;
  };

  // Navigation function for profile completion
  const navigateToProfile = () => {
    if (user?.role?.id) {
      const roleId = Number(user.role.id);
      if (roleId === 1) { // Professional
        navigate("/professional/profile");
      } else if (roleId === 2) { // International Professional
        navigate("/international-professional/profile");
      } else if (roleId === 3) { // Client
        navigate("/client/profile");
      } else if (roleId === 4) { // Admin
        navigate("/admin/profile");
      }
    }
  };

  // Get professional participant (role id 3 or 4)
  const getProfessionalParticipant = () => {
    if (!selectedChat?.chat?.participants) return null;
    return selectedChat.chat.participants.find(participant => {
      // Check if participant has role information - use type assertion for flexibility
      const participantAny = participant as any;
      const roleId = participantAny.role?.id || participantAny.roleId || participantAny.role;
      return Number(roleId) === 4 || Number(roleId) === 5;
    });
  };

  // Get client participant (role id 1)
  const getClientParticipant = () => {
    if (!selectedChat?.chat?.participants) return null;
    return selectedChat.chat.participants.find(participant => {
      const participantAny = participant as any;
      const roleId = participantAny.role?.id || participantAny.roleId || participantAny.role;
      return Number(roleId) === 2 || Number(roleId) === 3;
    });
  };

  // Handle profile view
  const handleViewProfile = () => {
    setIsProfilePopoverOpen(false);
    const professional = getProfessionalParticipant();
    const client = getClientParticipant();
    setSelectedProfessional(professional);
    setSelectedClient(client);
    setShowProfileDialog(true);
  };

  // Handle quote creation
  const handleCreateQuote = async () => {
    setIsProfilePopoverOpen(false);
    
    // Check if chat is blocked
    if (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) {
      GlobalService.showToast(
        "error",
        t("messagesAndVideoCall.chatBlocked"),
        t("messagesAndVideoCall.chatBlockedQuotes")
      );
      return;
    }
    
    // Check if user needs to complete profile and verification (only for professionals)
    if (Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional) {
      if (!checkRequirements()) {
        return;
      }
    }

    // If logged in and professional: check suspension status
    if (Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional) {
      // Find the other participant (client) from chat participants - anyone who is NOT the current user
      let otherParticipantId = null;
      if (selectedChat?.chat?.participants && Array.isArray(selectedChat.chat.participants)) {
        const otherParticipant = selectedChat.chat.participants.find((p: any) => p.id !== user?.id);
        otherParticipantId = otherParticipant?.id;
      }
      
      if (otherParticipantId) {
        try {
          const commCheck: any = await dispatch(checkCanCommunicate({ 
            professionalId: user.id, 
            clientId: otherParticipantId 
          })).unwrap();
          
          if (!commCheck.canCommunicate) {
            const suspensionEndDate = commCheck.suspensionEndDate 
              ? new Date(commCheck.suspensionEndDate).toLocaleDateString() 
              : "unknown date";
            
            if (commCheck.suspensionType === "new_clients_only") {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedNewClientsQuote", { date: suspensionEndDate })
              );
            } else {
              GlobalService.showToast(
                "error", 
                t("messagesAndVideoCall.communicationRestricted"), 
                t("messagesAndVideoCall.suspendedQuotesMessage", { date: suspensionEndDate })
              );
            }
            return;
          }
        } catch (error) {
          // Block quote creation if API check fails to be safe
          GlobalService.showToast(
            "error", 
            t("messagesAndVideoCall.unableToVerify"), 
            t("messagesAndVideoCall.tryAgainOrContact")
          );
          return;
        }
      }
    }

    // Proceed to show quote modal
    const professional = getProfessionalParticipant();
    const client = getClientParticipant();
    setSelectedProfessional(professional);
    setSelectedClient(client);
    setShowQuoteModal(true);
  };

  // Close profile dialog
  const handleCloseProfileDialog = () => {
    setShowProfileDialog(false);
  };

  // Close quote modal
  const handleCloseQuoteModal = () => {
    setShowQuoteModal(false);
  };

  // Handle contract detail view
  const handleViewContractDetail = (escrow: any) => {
    setSelectedContractEscrow(escrow);
    setShowContractDetailModal(true);
  };

  // Close contract detail modal
  const handleCloseContractDetailModal = (messageData?: any) => {
    setShowContractDetailModal(false);
    setSelectedContractEscrow(null);

    // Refresh chat and conversation data
    if (messageData) {
      setConversations(messageData);
    } else if (selectedChat?.chat?.id && user?.id) {
      dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
      dispatch(fetchConversations({
        chatId: selectedChat.chat.id,
        page: 1,
        limit: CONVERSATION_PAGE_SIZE
      }));
    }
  };

  // Refresh chat data after contract actions
  const handleRefreshChatData = (messageData?: any) => {
    if (messageData) {
      setConversations(messageData);
    } else {
      // Fallback to full refresh
      if (selectedChat?.chat?.id && user?.id) {
        dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
        dispatch(fetchConversations({
          chatId: selectedChat.chat.id,
          page: 1,
          limit: CONVERSATION_PAGE_SIZE
        }));
      }
    }
  };

  // Handle payment request view
  const handleViewPaymentRequest = (paymentRequest: any, milestoneId?: string) => {
    setSelectedPaymentRequest(paymentRequest);
    setSelectedMilestoneId(milestoneId || null);
    setShowPaymentRequestModal(true);
  };

  // Close payment request modal
  const handleClosePaymentRequestModal = (messageData?: any) => {
    setShowPaymentRequestModal(false);
    setSelectedPaymentRequest(null);
    setSelectedMilestoneId(null);

    // Refresh chat and conversation data
    return;
    if (messageData) {
      setConversations(messageData);
    } else if (selectedChat?.chat?.id && user?.id) {
      dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
      dispatch(fetchConversations({
        chatId: selectedChat.chat.id,
        page: 1,
        limit: CONVERSATION_PAGE_SIZE
      }));
    }
  };

  // Handle create contract
  const handleCreateContract = (offer: any) => {
    // Show loader for 2 seconds
    setTimeout(() => {
      setSelectedOfferForContract(offer);
      setShowCreateContractModal(true);
      setLoadingOffers(false);
      setShowFullScreenLoader(false);
    }, 100);
  };

  // Close create contract modal
  const handleCloseCreateContractModal = () => {
    setShowCreateContractModal(false);
    setSelectedOfferForContract(null);
  };

  // Handle create contract from button
  const handleCreateContractFromButton = async () => {
    // Show loader immediately for all users
    setLoadingOffers(true);
    setShowFullScreenLoader(true);
    
    // Small delay to ensure loader shows
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Check if user is a client
    if (Number(user?.role?.id) === RoleEnum.client) {
      try {
        // Fetch client offers
        const response = await dispatch(fetchUserOffers({
          page: 1,
          limit: 10, // Get all offers
          jobUserId: user.id,
          isSent: false, // Get offers received by the client
          statusIds: "2,3", // Approved and Accepted offers
          sort: [{ orderBy: "createdAt", order: "DESC" }]
        }));
        
        if (response.meta.requestStatus === "fulfilled") {
          setClientOffers((response.payload as any)?.data || []);
          setShowContractMilestoneModal(true);
        }
      } catch (error) {
        console.error("Error fetching client offers:", error);
      } finally {
        setLoadingOffers(false);
        setShowFullScreenLoader(false);
      }
      } else {
        // For non-clients, show a message or redirect
        alert(t("messagesAndVideoCall.onlyClientsCanCreate"));
        setLoadingOffers(false);
        setShowFullScreenLoader(false);
      }
  };

  // Close contract milestone modal
  const handleCloseContractMilestoneModal = () => {
    setShowContractMilestoneModal(false);
    setSelectedContractOffer(null);
  };

  // Handle payment request release (same logic as OrderDetailsModal)
  const handleRequestPaymentRelease = async (escrowRecord: any) => {
    try {
      console.log("Requesting payment release for milestone", escrowRecord);
      
      // Check if milestone has escrow data
      if (!escrowRecord) {
        GlobalService.showToast("error", t("toast.titles.error"), t("toast.messages.escrowNotFound"));
        throw new Error("Escrow not found for this milestone");
      }

      // Handle both cases: escrowRecord with milestone property, or milestone object directly
      const milestoneId = escrowRecord.milestone?.id || escrowRecord.id;
      
      if (!milestoneId) {
        GlobalService.showToast("error", t("toast.titles.error"), t("toast.messages.milestoneIdNotFound"));
        throw new Error("Milestone ID not found");
      }

      // Create milestone payment log for requested status
      const paymentLogData: MilestonePaymentLogCreateDto = {
        milestone: { id: milestoneId },
        paymentStatus: { id: MilestonePaymentStatusEnum.Requested }
      };

      await dispatch(createMilestonePaymentLog(paymentLogData)).unwrap();
      console.log("Milestone payment log created for requested status");

      // Handle both full escrow record and milestone-only scenarios
      const milestone = escrowRecord.milestone || escrowRecord;
      
      // Use the actual escrow data from the milestone
      const escrow = {
        id: escrowRecord.id || milestone.id,
        contract: escrowRecord.contract || {
          id: milestone.contract?.id,
          title: milestone.contract?.title || milestone.description,
          description: milestone.contract?.description || milestone.description,
          amount: milestone.contract?.amount || milestone.amount,
          type: { id: milestone.contract?.type?.id },
          status: { id: milestone.contract?.status?.id },
          enableTracker: milestone.contract?.enableTracker,
          weeklyLimit: milestone.contract?.weeklyLimit
        },
        client: escrowRecord.client || milestone.client,
        professional: { id: user?.id },
        amount: escrowRecord.amount || milestone.amount,
        emergencyCost: escrowRecord.emergencyCost || 0,
        trackerAmount: escrowRecord.trackerAmount || 0,
        platformFee: escrowRecord.platformFee || 0,
        totalAmount: escrowRecord.totalAmount || milestone.amount,
        status: { id: escrowRecord.status?.id || milestone.status?.id },
        milestone: {
          id: milestone.id,
          description: milestone.description,
          amount: milestone.amount,
          status: milestone.status,
          dueDate: milestone.dueDate,
          paymentStatus: milestone.paymentStatus
        },
        createdAt: escrowRecord.createdAt || milestone.createdAt,
        updatedAt: escrowRecord.updatedAt || milestone.updatedAt
      };

      // Create chat and send message (similar to OrderDetailsModal)
      const messageData = await createChatAndSendMessageForPaymentRequest(escrow);

      // Update escrow status to released (3)
      try {
        await escrowAPI.updateEscrow(escrow.id, { status: "released" });
        console.log("Escrow status updated to released (3) successfully");
      } catch (escrowError) {
        console.error("Error updating escrow status:", escrowError);
        GlobalService.showToast("warning", t("toast.titles.warning"), t("toast.messages.paymentReleaseWarning"));
      }

      setTimeout(() => {
        GlobalService.showToast("success", t("toast.titles.success"), t("toast.messages.paymentReleasedAndUpdated"));
        // Refresh chat data
        if (selectedChat?.chat?.id && user?.id) {
          dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
          dispatch(fetchConversations({
            chatId: selectedChat.chat.id,
            page: 1,
            limit: CONVERSATION_PAGE_SIZE
          }));
        }
      }, 500);

    } catch (error: any) {
      console.error("Failed to request payment release:", error);
      GlobalService.showToast("error", t("toast.titles.error"), t("toast.messages.paymentReleaseFailed", { error: error?.message || "Unknown error" }));
    }
  };

  // Function to create chat and send payment release message (similar to OrderDetailsModal)
  const createChatAndSendMessageForPaymentRequest = async (escrow: any) => {
    try {
      // Check if chat already exists between client and professional
      console.log("Creating chat and sending message with escrow ID:", escrow.id);
      let existingChat = null;
      try {
        existingChat = await dispatch(fetchParticipantChats({ currentUserId: escrow.client.id, page: 1, limit: 10 })).unwrap();
      } catch (error) {
        console.log("No existing chat found, will create new one");
      }

      let chatResponse;
      if (existingChat.chats && existingChat.chats.length > 0) {
        const filteredChats = existingChat.chats.filter((chat: any) => {
          const participantIds = chat.chat.participants.map((p: any) => p.id);
          return participantIds.includes(escrow.client.id) && participantIds.includes(escrow.professional.id);
        });
        const chat = filteredChats[0].chat;
        chatResponse = chat;

        // Update the chat with lastMessage and lastMessageAt
        if (chatResponse && chatResponse.id) {
          const updatedChat = {
            lastMessage: t("myOrdersPage.chat.paymentReleaseRequest"),
            lastMessageAt: new Date().toISOString(),
            unreadCount: { [escrow.client?.id]: 1, [escrow.professional?.id]: 0 },
          };
          await dispatch(updateChat({
            chatId: chatResponse.id,
            data: updatedChat
          }));
        }
      } else {
        // Create new chat
        console.log("Creating new chat for payment release with escrow ID:", escrow.id);
        chatResponse = await dispatch(createProfessionalChat({
          currentUserId: escrow.client.id,
          professionalId: escrow.professional.id,
          professionalName: escrow.professional.name || "Professional",
          lastMessage: t("myOrdersPage.chat.paymentReleaseRequest")
        })).unwrap();
        console.log("Created new chat for payment release:", chatResponse);
      }

      // Send payment release message with proper escrow contextId
      const conversationPayload = {
        isRead: false,
        message: t("myOrdersPage.chat.paymentReleaseRequested"),
        sender: { id: user.id },
        chatId: { id: chatResponse.id },
        type: { id: ConversationTypeEnum.Payment_Request },
        contextId: { id: escrow.id }, // This will now be the actual escrow ID
        attachments: [],
      };

      const conversation = await dispatch(createConversation({ data: conversationPayload })).unwrap();
      console.log("Payment release message sent with escrow contextId:", escrow.id);

      // Send WebSocket message to notify other participants
      const messageData = {
        type: "new_conversation",
        detail: {
          conversationId: conversation.id,
          conversation: conversation,
          chatId: conversation.chatId.id,
          message: conversationPayload.message,
          senderId: conversation.sender.id,
          attachments: conversationPayload.attachments,
          type: conversationPayload.type.id,
          referenceId: conversationPayload.contextId.id,
          timestamp: new Date().toISOString()
        }
      };

      try {
        if (sendWebSocketMessage) {
          const receivers = chatResponse.participants.map(p => p.id).filter(id => id !== user?.id);

          if (receivers.length > 0) {
            await sendWebSocketMessage({
              receivers,
              sender: user?.id || "",
              type: "new_conversation",
              detail: messageData.detail,
              conversationId: conversationPayload.chatId.id
            });
            console.log("📤 WebSocket message sent for payment release request");
          }
        }
      } catch (wsError) {
        console.warn("⚠️ Failed to send WebSocket message for payment release:", wsError);
        // Don't fail the entire operation if WebSocket fails
      }

      return messageData;
    } catch (error) {
      console.error("Error creating chat or sending message:", error);
      // Don't throw error here as the main action (payment release request) should still proceed
      return null;
    }
  };


  // Handle copy message text
  const handleCopyMessage = async (messageText: string) => {
    try {
      await navigator.clipboard.writeText(messageText);
      // You could show a toast notification here
    } catch (error) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = messageText;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  };

  // Handle reply to message
  const handleReplyToMessage = (messageId: string, messageText: string, sender: any, timestamp: string) => {
    dispatch(setReplyToMessage({ messageId, message: messageText, sender, timestamp }));
  };

  // Handle file download with proper error handling
  const handleFileDownload = async (filePath: string, fileName: string) => {
    try {
      // First try direct download
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      try {
        // Fallback: fetch the file and create a blob URL
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the blob URL
        window.URL.revokeObjectURL(blobUrl);
      } catch (fetchError) {
        // Final fallback: open in new tab
        window.open(filePath, "_blank");
      }
    }
  };

  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden" style={{ textAlign: "left" }}>
      {/* Full Screen Loader */}
      {showFullScreenLoader && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-8 flex flex-col items-center justify-center shadow-xl">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mb-4"></div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{t("messagesAndVideoCall.loadingContractData")}</h3>
            <p className="text-gray-600 text-center">{t("messagesAndVideoCall.fetchingOffers")}</p>
          </div>
        </div>
      )}
      
      {Number(user?.role?.id) === RoleEnum.client ? <SharedHeader5 /> : <SharedHeader4 />}

      <main className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {/* WebSocket Connection Status - Only show if there's an error */}
        {/* {user && (isWebSocketAuthError || (!isWebSocketConnected && !loading)) && (
          <div className="mb-4 flex justify-center">
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium ${isWebSocketAuthError
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
              }`}>
              <div className={`w-2 h-2 rounded-full ${isWebSocketAuthError
                ? "bg-yellow-500"
                : "bg-red-500"
                }`} />
              {isWebSocketAuthError
                ? "Authentication error - Please refresh to reconnect"
                : "Connecting to real-time messaging..."
              }
            </div>
          </div>
        )} */}

        {!user ? (
          <div className="flex-1 flex items-center justify-center bg-white">
            <div className="text-center p-8">
              <MessageSquare className="h-16 w-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-xl font-medium text-gray-900">{t("messagesAndVideoCall.pleaseLogIn")}</h3>
              <p className="text-sm text-gray-500 mt-2">
                {t("messagesAndVideoCall.needToLogin")}
              </p>
            </div>
          </div>
        ) : (
          <div className="flex-1 flex bg-white min-h-0">
            {/* Sidebar */}
            <AnimatePresence>
              {(isSidebarOpen || !isMobileView) && (
                <motion.div
                  initial={{ x: -320 }}
                  animate={{ x: 0 }}
                  exit={{ x: -320 }}
                  transition={{ type: "tween" }}
                  className={`${isMobileView ? "absolute z-10 bg-white h-full" : "relative"
                    } w-full sm:w-80 flex-shrink-0 border-r flex flex-col h-full max-h-full`}
                >
                  {/* Search */}
                  <div className="p-2 sm:p-4 border-b flex-shrink-0">
                    <div className="flex items-center gap-2 mb-3">
                      <h3 className="text-lg font-semibold text-gray-900">{t("messagesAndVideoCall.messages")}</h3>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => user?.id && dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }))}
                        disabled={loading && chats.length === 0}
                        className="ml-auto"
                      >
                        <div className="h-4 w-4">
                          {loading && chats.length === 0 ? (
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                          ) : (
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                          )}
                        </div>
                      </Button>
                    </div>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder={t("messagesAndVideoCall.searchConversations")}
                        value={searchQuery}
                        onChange={(e) => {
                          const query = e.target.value;
                          dispatch(setSearchQuery(query));
                        }}
                        className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      />
                      <Search className="absolute left-3 top-2.5 text-gray-400 h-5 w-5" />
                    </div>
                  </div>

                  {/* Chat List */}
                  <div className="flex-1 overflow-y-auto min-h-0 max-h-full">
                    {loading && chats.length === 0 ? (
                      <div className="flex items-center justify-center p-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                      </div>
                    ) : error ? (
                      <div className="p-4 text-center text-red-500">
                        {error}
                      </div>
                    ) : filteredChats.length === 0 ? (
                      <div className="p-4 text-center text-gray-500">
                        {searchQuery.trim() ? t("messagesAndVideoCall.noConversationsMatch") : t("messagesAndVideoCall.noConversationsFound")}
                      </div>
                    ) : (
                      filteredChats.map((chat, index) => {
                        const other = getNonAdminOtherParticipantFromContainer(chat, user?.id);
                        const otherAvatar = other?.photo?.path || other?.photo?.url || null;
                        const otherName = other?.name || (other?.firstName && other?.lastName ? `${other.firstName} ${other.lastName}` : other?.firstName) || "";
                        return (
                          <button
                            key={chat.id + index}
                            onClick={() => handleChatSelect(chat)}
                            className={`w-full p-2 sm:p-4 flex items-start gap-2 sm:gap-3 hover:bg-gray-50 transition-colors ${selectedChat?.id === chat.id ? "bg-blue-50" : ""}`}
                          >
                            <div className="relative flex-shrink-0">
                              {otherAvatar ? (
                                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden border border-gray-200">
                                  <img
                                    src={otherAvatar}
                                    alt={otherName || "User"}
                                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover"
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                      const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                                      if (nextElement) {
                                        nextElement.style.display = "flex";
                                      }
                                    }}
                                  />
                                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center" style={{ display: "none" }}>
                                    <User className="h-4 w-4 sm:h-6 sm:w-6 text-gray-400" />
                                  </div>
                                </div>
                              ) : (
                                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center">
                                  <User className="h-4 w-4 sm:h-6 sm:w-6 text-gray-400" />
                                </div>
                              )}
                              <div className={`absolute bottom-0 right-0 w-2 h-2 sm:w-3 sm:h-3 rounded-full border-2 border-white ${chat.status === "online" ? "bg-green-500" : "bg-gray-400"}`} />
                            </div>

                            <div className="flex-1 min-w-0">
                              <div className="flex justify-between items-start">
                                <div className="flex items-center gap-1 flex-1 min-w-0">
                                  <div className="font-medium truncate">{getChatDisplayName(chat)}</div>
                                  {chat?.chat?.status && Number(chat.chat.status.id) === ChatStatusEnum.flagged && (
                                    <span title={t("messagesAndVideoCall.flagged")}>
                                      <Flag className="h-3 w-3 text-yellow-500 flex-shrink-0" />
                                    </span>
                                  )}
                                  {chat?.chat?.status && Number(chat.chat.status.id) === ChatStatusEnum.blocked && (
                                    <span title={t("messagesAndVideoCall.blocked")}>
                                      <Shield className="h-3 w-3 text-red-500 flex-shrink-0" />
                                    </span>
                                  )}
                                </div>
                                <div className="text-xs text-gray-500 ml-2">{chat.timestamp}</div>
                              </div>
                              <div className="text-sm text-left text-gray-500 truncate">
                                {chat.lastMessage}
                              </div>
                            </div>

                            {getCurrentUserUnreadCount(chat) > 0 && (
                              <Badge variant={undefined} className="bg-blue-500 text-white">
                                {getCurrentUserUnreadCount(chat)}
                              </Badge>
                            )}
                          </button>
                        );
                      })
                    )}

                    {/* Pagination Controls */}
                    {!searchQuery.trim() && pagination.totalCount > 0 && (
                      <div className="p-4 border-t bg-gray-50">
                        <div className="flex items-center justify-between">
                          <div className="text-sm text-gray-600">
                            {t("messagesAndVideoCall.page", { 
                              current: pagination.currentPage, 
                              total: Math.ceil(pagination.totalCount / 10) 
                            })}
                            {" "}
                            {t("messagesAndVideoCall.totalChats", { count: pagination.totalCount })}
                          </div>
                          <div className="flex items-center gap-2">
                            <Button
                              onClick={handlePreviousPage}
                              disabled={!pagination.hasPreviousPage || loading}
                              variant="outline"
                              size="sm"
                              className="flex items-center gap-1"
                            >
                              <ArrowLeft className="h-4 w-4" />
                              {t("messagesAndVideoCall.previous")}
                            </Button>
                            <Button
                              onClick={handleNextPage}
                              disabled={!pagination.hasNextPage || loading}
                              variant="outline"
                              size="sm"
                              className="flex items-center gap-1"
                            >
                              {t("messagesAndVideoCall.next")}
                              <ArrowRight className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Chat/Call Area */}
            <div className="flex-1 flex flex-col relative min-h-0 max-h-full">
              {selectedChat ? (
                <>
                  {/* Call In Progress Banner */}
                  {(hasActiveCallInChat || localActiveCalls.length > 0) &&
                    !isInCall &&
                    !hasExplicitlyLeftCall &&
                    !isCameraAccessDisabled() && (
                    <div className="p-2 sm:p-4 border-b flex-shrink-0">
                      <CallInProgressBanner
                        activeCall={localActiveCalls[0] || activeCalls[0]}
                        currentUserId={user?.id || ""}
                        onJoinCall={() => handleJoinExistingCall(localActiveCalls[0] || activeCalls[0])}
                        onDismiss={() => {
                          // Dismiss the banner by marking as explicitly left
                          setHasExplicitlyLeftCall(true);
                        }}
                      />
                    </div>
                  )}

                  {/* Header */}
                  <div className="p-2 sm:p-4 border-b flex items-center justify-between flex-shrink-0">
                    <div className="flex items-center gap-1">
                      {isMobileView && (
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={handleBackToList}
                          className="mr-1"
                        >
                          <ArrowLeft className="h-5 w-5" />
                        </Button>
                      )}
                      <div className="relative">
                        {(() => {
                          const other = getNonAdminOtherParticipantFromContainer(selectedChat, user?.id);
                          const otherAvatar = other?.photo?.path || other?.photo?.url || null;
                          const otherName = other?.name || (other?.firstName && other?.lastName ? `${other.firstName} ${other.lastName}` : other?.firstName) || "";
                          return otherAvatar ? (
                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden border border-gray-200">
                              <img
                                src={otherAvatar}
                                alt={otherName || "User"}
                                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover"
                                onError={(e) => {
                                  e.currentTarget.style.display = "none";
                                  const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                                  if (nextElement) {
                                    nextElement.style.display = "flex";
                                  }
                                }}
                              />
                              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center" style={{ display: "none" }}>
                                <User className="h-4 w-4 sm:h-6 sm:w-6 text-gray-400" />
                              </div>
                            </div>
                          ) : (
                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-200 flex items-center justify-center">
                              <User className="h-4 w-4 sm:h-6 sm:w-6 text-gray-400" />
                            </div>
                          );
                        })()}
                        <div className={`absolute bottom-0 right-0 w-2 h-2 sm:w-3 sm:h-3 rounded-full border-2 border-white ${selectedChat.status === "online" ? "bg-green-500" : "bg-gray-400"}`} />
                      </div>
                      <div>
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{getChatDisplayName(selectedChat)}</span>
                          {selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.flagged && (
                            <span className="flex items-center gap-1 px-2 py-0.5 bg-yellow-50 border border-yellow-200 rounded-full" title="Flagged by admin">
                              <Flag className="h-3 w-3 text-yellow-600" />
                              <span className="text-xs text-yellow-700 font-medium">Flagged</span>
                            </span>
                          )}
                          {selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked && (
                            <span className="flex items-center gap-1 px-2 py-0.5 bg-red-50 border border-red-200 rounded-full" title="Blocked by admin">
                              <Shield className="h-3 w-3 text-red-600" />
                              <span className="text-xs text-red-700 font-medium">Blocked</span>
                            </span>
                          )}
                        </div>
                        <div className="text-sm text-gray-500">
                          {selectedChat.status === "online" ? t("messagesAndVideoCall.online") : t("messagesAndVideoCall.offline")}
                        </div>
                        {/* Typing Indicator in Header */}
                        {typingUsers.length > 0 && (
                          <div className="flex items-center gap-1 mt-1">
                            <div className="flex space-x-1">
                              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce"></div>
                              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0.1s" }}></div>
                              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
                            </div>
                            <div className="text-xs text-blue-600">
                              {typingUsers.length === 1
                                ? t("messagesAndVideoCall.isTyping", { name: typingUsers[0].userName || "Someone" })
                                : t("messagesAndVideoCall.peopleTyping", { count: typingUsers.length })
                              }
                            </div>
                          </div>
                        )}
                        {/* Display unread count for current user */}
                        {getCurrentUserUnreadCount(selectedChat) > 0 && (
                          <div className="text-xs text-blue-600 font-medium mt-1">
                            {getCurrentUserUnreadCount(selectedChat) > 1 
                              ? t("messagesAndVideoCall.unreadMessages", { count: getCurrentUserUnreadCount(selectedChat) })
                              : t("messagesAndVideoCall.unreadMessage", { count: getCurrentUserUnreadCount(selectedChat) })
                            }
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      {/* Desktop: Show call buttons directly */}
                      <div className="hidden lg:flex items-center gap-2">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleStartCall(CallType.AUDIO)}
                          title={!selectedChat ? t("messagesAndVideoCall.selectChatToCall") : (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? t("messagesAndVideoCall.chatIsBlocked") : isCameraAccessDisabled() ? t("messagesAndVideoCall.cameraAccessDenied") : t("messagesAndVideoCall.audioCall")}
                          disabled={!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                          className={(!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)) ? "opacity-50 cursor-not-allowed" : ""}
                        >
                          <Phone className="h-5 w-5" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleStartCall(CallType.VIDEO)}
                          title={!selectedChat ? t("messagesAndVideoCall.selectChatToCall") : (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? t("messagesAndVideoCall.chatIsBlocked") : isCameraAccessDisabled() ? t("messagesAndVideoCall.cameraAccessDenied") : t("messagesAndVideoCall.videoCall")}
                          disabled={!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                          className={(!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)) ? "opacity-50 cursor-not-allowed" : ""}
                        >
                          <Video className="h-5 w-5" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={handleViewProfile}
                          title={t("messagesAndVideoCall.viewProfile")}
                          className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                        >
                          <Eye className="h-4 w-4 mr-2" />
                          <span className="text-sm">{t("messagesAndVideoCall.viewProfile")}</span>
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={handleCreateQuote}
                          title={t("messagesAndVideoCall.createQuote")}
                          className="text-green-600 hover:text-green-700 hover:bg-green-50"
                        >
                          <FileText className="h-4 w-4 mr-2" />
                          <span className="text-sm">{t("messagesAndVideoCall.createQuote")}</span>
                        </Button>
                        {Number(user?.role?.id) === RoleEnum.client && (
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={handleCreateContractFromButton}
                            title={t("messagesAndVideoCall.createContract")}
                            disabled={loadingOffers}
                            className="text-purple-600 hover:text-purple-700 hover:bg-purple-50 disabled:opacity-50"
                          >
                            {loadingOffers ? (
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600 mr-2"></div>
                            ) : (
                              <FileText className="h-4 w-4 mr-2" />
                            )}
                            <span className="text-sm">{loadingOffers ? t("messagesAndVideoCall.loading") : t("messagesAndVideoCall.createContract")}</span>
                          </Button>
                        )}
                      </div>

                      {/* Mobile/Tablet: Show call button and popover with all actions */}
                      <div className="xl:hidden flex items-center gap-2">
                        {/* Audio call button */}
                        {/* <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleStartCall(CallType.AUDIO)}
                          title="Audio Call"
                          disabled={!selectedChat}
                          className={!selectedChat ? "opacity-50 cursor-not-allowed" : "text-green-600 hover:text-green-700 hover:bg-green-50"}
                        >
                          <Phone className="h-5 w-5" />
                        </Button> */}

                        {/* More actions popover */}
                        <div className="relative profile-popover-container">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => setIsProfilePopoverOpen(!isProfilePopoverOpen)}
                          >
                            <MoreVertical className="h-5 w-5" />
                          </Button>

                          {/* Profile Actions Popover */}
                          {isProfilePopoverOpen && (
                            <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-md shadow-lg border z-50">
                              <div className="py-1">
                                <button
                                  onClick={() => handleStartCall(CallType.AUDIO)}
                                  disabled={isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                                  className={`flex items-center w-full px-4 py-2 text-sm ${isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "text-gray-400 cursor-not-allowed" : "text-gray-700 hover:bg-gray-100"} transition-colors`}
                                  title={(selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? t("messagesAndVideoCall.chatIsBlocked") : isCameraAccessDisabled() ? t("messagesAndVideoCall.cameraAccessDenied") : t("messagesAndVideoCall.audioCall")}
                                >
                                  <Phone className="h-4 w-4 mr-2 text-blue-600" />
                                  {t("messagesAndVideoCall.audioCall")}
                                </button>
                                <button
                                  onClick={() => handleStartCall(CallType.VIDEO)}
                                  disabled={isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                                  className={`flex items-center w-full px-4 py-2 text-sm ${isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "text-gray-400 cursor-not-allowed" : "text-gray-700 hover:bg-gray-100"} transition-colors`}
                                  title={(selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? t("messagesAndVideoCall.chatIsBlocked") : isCameraAccessDisabled() ? t("messagesAndVideoCall.cameraAccessDenied") : t("messagesAndVideoCall.videoCall")}
                                >
                                  <Video className="h-4 w-4 mr-2 text-blue-600" />
                                  {t("messagesAndVideoCall.videoCall")}
                                </button>
                                <button
                                  onClick={handleViewProfile}
                                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                >
                                  <Eye className="h-4 w-4 mr-2 text-blue-600" />
                                  {t("messagesAndVideoCall.viewProfile")}
                                </button>
                                <button
                                  onClick={handleCreateQuote}
                                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                >
                                  <FileText className="h-4 w-4 mr-2" />
                                  {t("messagesAndVideoCall.createQuote")}
                                </button>
                                {Number(user?.role?.id) === RoleEnum.client && (
                                  <button
                                    onClick={handleCreateContractFromButton}
                                    disabled={loadingOffers}
                                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    {loadingOffers ? (
                                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600 mr-2"></div>
                                    ) : (
                                      <FileText className="h-4 w-4 mr-2" />
                                    )}
                                    {loadingOffers ? t("messagesAndVideoCall.loading") : t("messagesAndVideoCall.createContract")}
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>

                  {isInCall ? (
                    // Agora Video Call UI with Built-in Controls
                    <div className="flex-1 min-h-0">
                      <AgoraVideoCallWithControls
                        channelName={channelName}
                        callType={callType}
                        participantName={selectedChat?.name || "Professional"}
                        onCallEnd={currentCall?.initiatedBy === user?.id ? handleEndCall : handleLeaveCall}
                        autoStart={true}
                        className="w-full h-full"
                        onError={(error) => {
                          console.error("Video call error:", error);
                          // You could show a toast here
                        }}
                      />
                    </div>
                  ) : (
                    // Chat UI
                    <>
                      <div
                        ref={messageContainerRef}
                        onScroll={handleMessageScroll}
                        className="flex-1 p-3 sm:p-4 lg:p-6 overflow-y-auto flex flex-col min-h-0 max-h-full"
                      >
                        {(loading || conversationsLoading) && conversations.length === 0 && messages.length === 0 ? (
                          <div className="flex items-center justify-center p-8">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                          </div>
                        ) : conversations.length === 0 && messages.length === 0 ? (
                          <div className="text-center text-gray-500 p-8">
                            {t("messagesAndVideoCall.noMessagesYet")}
                          </div>
                        ) : (
                          <div className="space-y-3 sm:space-y-4">
                            {isLoadingOlderConversations && (
                              <div className="flex justify-center py-2">
                                <div className="h-5 w-5 border-b-2 border-blue-500 rounded-full animate-spin"></div>
                              </div>
                            )}
                            {(conversations.length > 0 ? conversations : messages).map((item,index) => {
                              // Handle both conversation and message formats
                              const msg = conversations.length > 0 ? {
                                id: item.id,
                                sender: item.sender.id === user?.id ? "Me" : "Other",
                                content: item.message,
                                timestamp: formatTimestamp(item.createdAt || ""),
                                status: item.isRead ? "read" : "sent",
                                isMine: item.sender.id === user?.id,
                                contextId: item.contextId || "",
                                attachments: item.attachments,
                                senderName: item.sender?.firstName && item.sender?.lastName
                                  ? `${item.sender.firstName} ${item.sender.lastName}`
                                  : item.sender?.firstName || item.sender?.email || "Unknown User",
                                senderAvatar: item.sender?.photo?.path || null,
                                isAdmin: Number(item.sender?.role?.id) === 1,
                                isQuote: Number(item?.type?.id) === ConversationTypeEnum.Quote,
                                isContract: Number(item?.type?.id) === ConversationTypeEnum.Contract,
                                isPaymentRequest: Number(item?.type?.id) === ConversationTypeEnum.Payment_Request,
                                isQuoteAccepted: Number(item?.type?.id) === ConversationTypeEnum.Quote_Accepted,
                                isQuoteRejected: Number(item?.type?.id) === ConversationTypeEnum.Quote_Rejected,
                                isContractAccepted: Number(item?.type?.id) === ConversationTypeEnum.Contract_Accepted,
                                isContractRejected: Number(item?.type?.id) === ConversationTypeEnum.Contract_Rejected,
                                isPaymentRequestAccepted: Number(item?.type?.id) === ConversationTypeEnum.Payment_Request_Accepted,
                                isPaymentRequestRejected: Number(item?.type?.id) === ConversationTypeEnum.Payment_Request_Rejected,
                                isCallStarted: Number(item?.type?.id) === ConversationTypeEnum.call_started,
                                isMissedCall: Number(item?.type?.id) === ConversationTypeEnum.missed_call
                              } : item;

                              // Check if there are more than 2 participants
                              const hasMultipleParticipants = selectedChat?.chat?.participants?.length > 2;

                              return (
                                <div
                                  key={`${msg.id}-${index}`}
                                  className={`flex ${msg.isMine ? "justify-end" : "justify-start"} group relative`}
                                >
                                  {/* Copy and Reply buttons - positioned outside message bubble */}
                                  <div className={`flex items-center gap-1 self-start mt-2 ${
                                    msg.isMine ? "order-first mr-1 sm:mr-2" : "order-last ml-1 sm:ml-2"
                                  } opacity-0 group-hover:opacity-100 transition-opacity duration-200`}>
                                    <button
                                      onClick={() => handleReplyToMessage(
                                        item.id,
                                        msg.content,
                                        item.sender,
                                        item.createdAt || ""
                                      )}
                                      className="p-1.5 sm:p-2 rounded-full bg-white shadow-md hover:bg-gray-100 transition-colors"
                                      title="Reply to message"
                                    >
                                      <Reply className="h-3 w-3 sm:h-4 sm:w-4 text-gray-600" />
                                    </button>
                                    <button
                                      onClick={() => handleCopyMessage(msg.content)}
                                      className="p-1.5 sm:p-2 rounded-full bg-white shadow-md hover:bg-gray-100 transition-colors"
                                      title="Copy message"
                                    >
                                      <Copy className="h-3 w-3 sm:h-4 sm:w-4 text-gray-600" />
                                    </button>
                                  </div>

                                  <div className={`${msg.isQuote || msg.isContract || msg.isPaymentRequest || msg.isQuoteAccepted || msg.isQuoteRejected || msg.isContractAccepted || msg.isContractRejected || msg.isPaymentRequestAccepted || msg.isPaymentRequestRejected || msg.isCallStarted || msg.isMissedCall ? "w-full sm:w-[85%] lg:w-[70%] xl:w-[60%]" : "max-w-[85%] sm:max-w-[75%] lg:max-w-[65%] xl:max-w-[55%]"} ${msg.isQuote ? "bg-white border border-green-200" :
                                    msg.isContract ? "bg-white border border-blue-200" :
                                      msg.isPaymentRequest ? "bg-white border border-purple-200" :
                                        msg.isQuoteAccepted ? "bg-white border border-emerald-200" :
                                          msg.isQuoteRejected ? "bg-white border border-red-200" :
                                            msg.isContractAccepted ? "bg-white border border-green-200" :
                                              msg.isContractRejected ? "bg-white border border-red-200" :
                                                msg.isPaymentRequestAccepted ? "bg-white border border-emerald-200" :
                                                  msg.isPaymentRequestRejected ? "bg-white border border-red-200" :
                                                    msg.isCallStarted ? "bg-white border border-blue-200" :
                                                      msg.isMissedCall ? "bg-white border border-orange-200" :
                                                        (msg.isAdmin ? "bg-green-100 text-gray-900" : (msg.isMine ? "bg-blue-600 text-white" : "bg-gray-100"))
                                    } ${msg.isMine ? "rounded-l-lg rounded-br-lg" : "rounded-r-lg rounded-bl-lg"} p-3 sm:p-4 relative`}>

                                    {/* Reply to message display */}
                                    {item.replyTo && (
                                      <div className="mb-2 p-2 bg-gray-100 border-l-4 border-blue-500 rounded text-sm w-full overflow-hidden">
                                        <div className="font-medium text-gray-600 mb-1 text-xs sm:text-sm break-words">
                                          Replying to {item.replyTo.sender.firstName || item.replyTo.sender.name || "Unknown"}
                                        </div>
                                        <div className="text-gray-700 text-xs sm:text-sm break-words line-clamp-2 overflow-hidden">
                                          {item.replyTo.message}
                                        </div>
                                      </div>
                                    )}

                                    {/* Show sender name and avatar for every message */}
                                    <div className="flex items-center gap-2 mb-2">
                                      {msg.senderAvatar ? (
                                        <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden border border-gray-200">
                                          <img
                                            src={msg.senderAvatar}
                                            alt={msg.senderName}
                                            className="w-5 h-5 sm:w-6 sm:h-6 rounded-full object-cover"
                                            onError={(e) => {
                                              e.currentTarget.style.display = "none";
                                              const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                                              if (nextElement) {
                                                nextElement.style.display = "flex";
                                              }
                                            }}
                                          />
                                          <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gray-300 flex items-center justify-center" style={{ display: "none" }}>
                                            <User className="h-3 w-3 sm:h-4 sm:w-4 text-gray-600" />
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gray-300 flex items-center justify-center">
                                          <User className="h-3 w-3 sm:h-4 sm:w-4 text-gray-600" />
                                        </div>
                                      )}
                                      <span className={`text-xs font-medium ${msg.isMine ? "text-blue-200" : "text-gray-700"}`}>
                                        {msg.isMine ? t("refundRequestsPage.you") : msg.senderName}
                                      </span>
                                    </div>

                                    {/* Quote-styled message */}
                                    {msg.isQuote ? (
                                      <div className="space-y-2 border-l-4 border-green-500 pl-3">
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                        <div
                                          className="inline-flex items-center gap-2 text-green-700 px-2 py-0.5 underline rounded text-xs font-medium cursor-pointer"
                                          onClick={() => {
                                            if (!item?.referenceId && !item?.reference?.id && !item?.referenceID) return;
                                            const refId = String(item?.referenceId || item?.reference?.id || item?.referenceID);
                                            dispatch(fetchOffer(refId)).then((res: any) => {
                                              if (res?.meta?.requestStatus === "fulfilled") {
                                                if (Number(user?.role?.id) === RoleEnum.client) {
                                                  
                                                  const offer = mapOfferFromAPI(res.payload);
                                                  console.log("res.payload", res.payload);
                                                  setSelectedClientOffer(offer);
                                                  setShowClientOfferModal(true);
                                                }
                                                else {
                                                  // Show offer details modal for non-clients (professionals, admins, etc.)
                                                  setSelectedOfferDetails(res.payload);
                                                  setShowOfferDetailsModal(true);
                                                }

                                              }
                                            });
                                          }}
                                        >
                                          {t("messagesAndVideoCall.viewQuoteDetails")}
                                        </div>
                                      </div>
                                    ) : msg.isContract ? (
                                      <div className="space-y-2 border-l-4 border-blue-500 pl-3">
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                        <div
                                          className="inline-flex items-center gap-2 text-blue-700 px-2 py-0.5 underline rounded text-xs font-medium cursor-pointer"
                                          onClick={() => {
                                            console.log("mmm", msg);
                                            if (!item?.contextId) {
                                              console.log("❌ No contextId (escrow) found for contract");
                                              return;
                                            }

                                            console.log("🔍 Opening contract detail modal:", item.contextId);
                                            if (Number(user?.role?.id) === RoleEnum.client) {
                                              localStorage.setItem("myOrdersSelectedTab", "active");
                                              navigate("/client/myorders");
                                            }
                                            else {
                                              // Show contract detail modal with escrow data
                                              handleViewContractDetail(item.contextId);
                                            }

                                          }}
                                        >
                                          {t("messagesAndVideoCall.viewContractDetails")}
                                        </div>
                                      </div>
                                    ) : msg.isPaymentRequest ? (
                                      <div className="space-y-2 border-l-4 border-purple-500 pl-3">
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                        <div
                                          className="inline-flex items-center gap-2 text-purple-700 px-2 py-0.5 underline rounded text-xs font-medium cursor-pointer"
                                          onClick={() => {
                                            console.log("mmm", item, msg);
                                            if (!item?.contextId) {
                                              console.log("❌ No contextId (escrow) found for payment request");
                                              return;
                                            }

                                            console.log("🔍 Opening payment request modal:", item.contextId);

                                            // Create payment request data from escrow
                                            const paymentRequestData = {
                                              id: item.contextId.id,
                                              amount: item.contextId.amount || 0,
                                              currency: item.contextId.currency?.name || "USD",
                                              description: item.message || item.content,
                                              status: item.contextId.status?.name?.toLowerCase() || "pending",
                                              requestedBy: item.sender,
                                              createdAt: item.createdAt,
                                              attachments: item.attachments || [],
                                              escrow: item.contextId
                                            };

                                            // Show payment request modal
                                            // Extract milestone ID from escrow if available
                                            const milestoneId = item.contextId?.milestone?.id;
                                            handleViewPaymentRequest(paymentRequestData, milestoneId);
                                          }}
                                        >
                                          {t("messagesAndVideoCall.viewPaymentRequestDetails")}
                                        </div>
                                      </div>
                                    ) : msg.isQuoteAccepted ? (
                                      <div className="space-y-2 border-l-4 border-emerald-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-emerald-700">{t("messagesAndVideoCall.quoteAccepted")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                        {Number(user?.role?.id) === RoleEnum.client && <div className="mt-3">
                                          <button
                                            onClick={() => {
                                              if (!item?.referenceId && !item?.reference?.id && !item?.referenceID) return;
                                              
                                              // Show loader immediately
                                              setLoadingOffers(true);
                                              setShowFullScreenLoader(true);
                                              
                                              const refId = String(item?.referenceId || item?.reference?.id || item?.referenceID);
                                              dispatch(fetchOffer(refId)).then((res: any) => {
                                                if (res?.meta?.requestStatus === "fulfilled") {
                                                  handleCreateContract(res.payload);
                                                } else {
                                                  // Hide loader if fetch fails
                                                  setLoadingOffers(false);
                                                  setShowFullScreenLoader(false);
                                                }
                                              }).catch(() => {
                                                // Hide loader on error
                                                setLoadingOffers(false);
                                                setShowFullScreenLoader(false);
                                              });
                                            }}
                                            className="inline-flex items-center gap-2 text-emerald-700 px-3 py-1.5 bg-emerald-50 hover:bg-emerald-100 rounded text-sm font-medium transition-colors"
                                          >
                                            <FileText className="h-4 w-4" />
                                            {t("messagesAndVideoCall.createContract")}
                                          </button>
                                        </div>}
                                      </div>
                                    ) : msg.isQuoteRejected ? (
                                      <div className="space-y-2 border-l-4 border-red-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-red-700">{t("messagesAndVideoCall.quoteRejected")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : msg.isContractAccepted ? (
                                      <div className="space-y-2 border-l-4 border-green-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-green-700">{t("messagesAndVideoCall.contractAccepted")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : msg.isContractRejected ? (
                                      <div className="space-y-2 border-l-4 border-red-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-red-700">{t("messagesAndVideoCall.contractRejected")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : msg.isPaymentRequestAccepted ? (
                                      <div className="space-y-2 border-l-4 border-emerald-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-emerald-700">{t("messagesAndVideoCall.paymentRequestAccepted")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : msg.isPaymentRequestRejected ? (
                                      <div className="space-y-2 border-l-4 border-red-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                          <span className="text-sm font-medium text-red-700">{t("messagesAndVideoCall.paymentRequestRejected")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                        <div className="flex gap-2 mt-3">
                                          <button
                                            onClick={() => {
                                              console.log("item", item);
                                              // Show rejection details dialog
                                              setSelectedRejectionData({
                                                milestone: item.contextId?.milestone,
                                                milestoneId: item.contextId?.milestone?.id,
                                                escrow: item.contextId
                                              });
                                              setShowRejectionDialog(true);
                                            }}
                                            className="inline-flex items-center gap-1 text-red-700 px-3 py-1.5 bg-red-50 hover:bg-red-100 rounded text-sm font-medium transition-colors"
                                          >
                                            <Eye className="h-4 w-4" />
                                            {t("messagesAndVideoCall.viewDetails")}
                                          </button>
                                        </div>
                                      </div>
                                    ) : msg.isCallStarted ? (
                                      <div className="space-y-2 border-l-4 border-blue-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <Phone className="h-4 w-4 text-blue-500" />
                                          <span className="text-sm font-medium text-blue-700">{t("messagesAndVideoCall.callStarted")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : msg.isMissedCall ? (
                                      <div className="space-y-2 border-l-4 border-orange-500 pl-3">
                                        <div className="flex items-center gap-2">
                                          <PhoneOff className="h-4 w-4 text-orange-500" />
                                          <span className="text-sm font-medium text-orange-700">{t("messagesAndVideoCall.missedCall")}</span>
                                        </div>
                                        {msg.content && (
                                          <div className="text-sm text-gray-800 whitespace-pre-wrap">{msg.content}</div>
                                        )}
                                      </div>
                                    ) : (
                                      msg.content && (
                                        <div className="text-sm break-words overflow-wrap-anywhere whitespace-pre-wrap">{msg.content}</div>
                                      )
                                    )}
                                    {msg.attachments && msg.attachments.length > 0 && (
                                      <div className="mt-2 space-y-2">
                                        {msg.attachments.map((attachment, index) => {
                                          const fileId = attachment.id;
                                          const filePath = attachment.path;

                                          // Extract filename and type from file.path URL
                                          let fileName = attachment.name || attachment.originalName || attachment.fileName;
                                          let fileType = attachment.type || attachment.mimeType || attachment.contentType;

                                          if (filePath) {
                                            try {
                                              // Extract filename from URL path
                                              const urlPath = filePath;
                                              const pathParts = urlPath.split("/");
                                              const fullFileName = pathParts[pathParts.length - 1]; // Get the last part of the URL

                                              if (fullFileName && fullFileName.includes(".")) {
                                                // Extract filename without extension
                                                const fileNameParts = fullFileName.split(".");
                                                const extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
                                                fileName = fileNameParts.slice(0, -1).join(".") || fullFileName;

                                                // Determine MIME type from extension
                                                if (!fileType) {
                                                  const mimeTypes: { [key: string]: string } = {
                                                    "jpg": "image/jpeg",
                                                    "jpeg": "image/jpeg",
                                                    "png": "image/png",
                                                    "gif": "image/gif",
                                                    "bmp": "image/bmp",
                                                    "webp": "image/webp",
                                                    "svg": "image/svg+xml",
                                                    "mp4": "video/mp4",
                                                    "webm": "video/webm",
                                                    "mov": "video/quicktime",
                                                    "avi": "video/x-msvideo",
                                                    "mkv": "video/x-matroska",
                                                    "flv": "video/x-flv",
                                                    "wmv": "video/x-ms-wmv",
                                                    "m4v": "video/x-m4v",
                                                    "3gp": "video/3gpp",
                                                    "ogv": "video/ogg",
                                                    "pdf": "application/pdf",
                                                    "doc": "application/msword",
                                                    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                    "txt": "text/plain",
                                                    "rtf": "application/rtf"
                                                  };
                                                  fileType = mimeTypes[extension] || "application/octet-stream";
                                                }
                                              }
                                            } catch (error) {
                                              console.error("Error parsing file path:", error);
                                            }
                                          }

                                          // Determine if it's an image or video based on MIME type
                                          const isImage = fileType?.startsWith("image/");
                                          const isVideo = fileType?.startsWith("video/");
                                          const isPdf = fileType === "application/pdf";
                                          const isDoc = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain", "application/rtf"].includes(fileType || "");

                                          return (
                                            <div key={index} className="attachment-container">
                                              {isImage && (
                                                <div className="image-preview relative group">
                                                  <img
                                                    src={filePath}
                                                    alt={fileName}
                                                    className="max-w-full max-h-48 rounded-lg cursor-pointer hover:opacity-80 transition-opacity"
                                                    onClick={() => window.open(filePath, "_blank")}
                                                  />
                                                  <button
                                                    onClick={() => handleFileDownload(filePath, fileName)}
                                                    className="absolute top-2 right-2 bg-black bg-opacity-50 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                                                    title={t("messagesAndVideoCall.downloadImage")}
                                                  >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              )}
                                              {isVideo && (
                                                <div className="video-preview relative group">
                                                  <video
                                                    controls
                                                    className="max-w-full max-h-48 rounded-lg"
                                                    preload="metadata"
                                                  >
                                                    <source src={filePath} type={fileType} />
                                                    Your browser does not support the video tag.
                                                  </video>
                                                  <button
                                                    onClick={() => handleFileDownload(filePath, fileName)}
                                                    className="absolute top-2 right-2 bg-black bg-opacity-50 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                                                    title={t("messagesAndVideoCall.downloadVideo")}
                                                  >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              )}
                                              {(isPdf || isDoc) && (
                                                <div className="file-download">
                                                  <button
                                                    onClick={() => handleFileDownload(filePath, fileName)}
                                                    className="flex items-center gap-2 p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer w-full text-left"
                                                  >
                                                    {isPdf ? (
                                                      <span className="text-red-500">📄</span>
                                                    ) : (
                                                      <span className="text-blue-500">📄</span>
                                                    )}
                                                    <span className="text-sm truncate">{fileName}</span>
                                                    <span className="text-xs text-gray-500">{t("messagesAndVideoCall.clickToDownload")}</span>
                                                  </button>
                                                </div>
                                              )}
                                              {!isImage && !isVideo && !isPdf && !isDoc && (
                                                <div className="file-download">
                                                  <button
                                                    onClick={() => handleFileDownload(filePath, fileName)}
                                                    className="flex items-center gap-2 p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer w-full text-left"
                                                  >
                                                    <span className="text-gray-500">📎</span>
                                                    <span className="text-sm truncate">{fileName}</span>
                                                    <span className="text-xs text-gray-500">{t("messagesAndVideoCall.clickToDownload")}</span>
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                    <div className="flex items-center gap-1 mt-1 justify-end">
                                      <span className={`text-xs ${msg.isMine ? "text-blue-200" : "text-gray-500"
                                        }`}>
                                        {msg.timestamp}
                                      </span>
                                      {msg.isMine && (
                                        msg.status === "read" ? (
                                          <CheckCheck className="h-3 w-3 text-blue-200" />
                                        ) : (
                                          <Check className="h-3 w-3 text-blue-200" />
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            {/* Typing Indicator */}
                            {typingUsers.length > 0 && (
                              <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg mx-4 mb-2">
                                <div className="flex space-x-1">
                                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0.1s" }}></div>
                                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
                                </div>
                                <div className="text-sm text-gray-600">
                                  {typingUsers.length === 1
                                    ? t("messagesAndVideoCall.isTyping", { name: typingUsers[0].userName || "Someone" })
                                    : t("messagesAndVideoCall.peopleTyping", { count: typingUsers.length })
                                  }
                                </div>
                              </div>
                            )}

                            {/* Scroll target for auto-scroll */}
                            <div ref={messagesEndRef} />
                          </div>
                        )}
                      </div>

                      <div className="p-3 sm:p-4 border-t flex-shrink-0 bg-white">
                        {/* Blocked Chat Warning */}
                        {selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked && (
                          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                            <div className="flex items-start gap-2">
                              <Shield className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
                              <div className="flex-1">
                                <p className="text-sm font-medium text-red-800 mb-1">
                                  {t("messagesAndVideoCall.conversationBlockedWarning")}
                                </p>
                                <p className="text-xs text-red-700">
                                  {t("messagesAndVideoCall.conversationBlockedDesc")}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Flagged Chat Warning */}
                        {selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.flagged && (
                          <div className="mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                            <div className="flex items-start gap-2">
                              <Flag className="h-5 w-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                              <div className="flex-1">
                                <p className="text-sm font-medium text-yellow-800 mb-1">
                                  {t("messagesAndVideoCall.conversationMonitored")}
                                </p>
                                <p className="text-xs text-yellow-700">
                                  {t("messagesAndVideoCall.conversationFlagged")}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Reply Preview */}
                        {replyToMessage && (
                          <div className="mb-2 sm:mb-3 p-2 sm:p-3 bg-blue-50 border-l-4 border-blue-500 rounded-lg w-full overflow-hidden">
                            <div className="flex items-start justify-between gap-2">
                              <div className="flex-1 min-w-0 overflow-hidden">
                                <div className="text-xs sm:text-sm font-medium text-blue-700 mb-1 break-words">
                                  {t("messagesAndVideoCall.replyingTo", { name: replyToMessage.sender.firstName || replyToMessage.sender.name || "Unknown" })}
                                </div>
                                <div className="text-xs sm:text-sm text-blue-600 break-words line-clamp-2 overflow-hidden">
                                  {replyToMessage.message}
                                </div>
                              </div>
                              <button
                                onClick={() => dispatch(clearReplyToMessage())}
                                className="flex-shrink-0 p-1 hover:bg-blue-200 rounded-full transition-colors"
                                title={t("messagesAndVideoCall.cancelReply")}
                              >
                                <X className="h-3 w-3 sm:h-4 sm:w-4 text-blue-600" />
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Selected Files Display */}
                        {selectedFiles.length > 0 && (
                          <div className="mb-2 sm:mb-3 p-2 bg-gray-50 rounded-lg">
                            <div className="text-xs sm:text-sm font-medium text-gray-700 mb-2">{t("messagesAndVideoCall.selectedFiles")}</div>
                            <div className="space-y-1 sm:space-y-2">
                              {selectedFiles.map((file, index) => {
                                const fileType = file.type || file.name.split(".").pop()?.toLowerCase();
                                const isImage = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml"].includes(file.type || "");
                                const isVideo = ["video/mp4", "video/avi", "video/mov", "video/wmv", "video/flv", "video/webm"].includes(file.type || "");
                                const isPdf = file.type === "application/pdf";
                                const isDoc = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain"].includes(file.type || "");

                                // Create a unique file ID for tracking upload progress
                                const fileId = `${file.name}-${file.size}-${Date.now()}`;
                                const isUploading = uploadingFiles.has(fileId);
                                const progress = uploadProgress[fileId] || 0;

                                return (
                                  <div key={index} className="flex items-center justify-between text-xs sm:text-sm">
                                    <div className="flex items-center gap-1 sm:gap-2 flex-1 min-w-0">
                                      {isImage && <span className="text-green-500 text-sm sm:text-base">🖼️</span>}
                                      {isVideo && <span className="text-purple-500 text-sm sm:text-base">🎥</span>}
                                      {isPdf && <span className="text-red-500 text-sm sm:text-base">📄</span>}
                                      {isDoc && <span className="text-blue-500 text-sm sm:text-base">📄</span>}
                                      {!isImage && !isVideo && !isPdf && !isDoc && <span className="text-gray-500 text-sm sm:text-base">📎</span>}
                                      <span className="truncate text-xs sm:text-sm">{file.name}</span>

                                      {/* Upload Progress Indicator */}
                                      {isUploading && (
                                        <div className="flex items-center gap-2 ml-2">
                                          <div className="w-4 h-4">
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                                          </div>
                                          <div className="text-xs text-blue-600">
                                            {Math.round(progress)}%
                                          </div>
                                        </div>
                                      )}

                                      {/* Upload Complete Indicator */}
                                      {!isUploading && progress === 100 && (
                                        <div className="flex items-center gap-1 ml-2">
                                          <div className="w-4 h-4 rounded-full bg-green-500 flex items-center justify-center">
                                            <Check className="h-3 w-3 text-white" />
                                          </div>
                                          <span className="text-xs text-green-600">{t("messagesAndVideoCall.uploaded")}</span>
                                        </div>
                                      )}
                                    </div>

                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      onClick={() => removeFile(index)}
                                      className="text-red-500 hover:text-red-700 flex-shrink-0"
                                      disabled={isUploading}
                                    >
                                      ×
                                    </Button>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* Mobile Layout: Stacked */}
                        <div className="flex flex-col gap-2 sm:hidden">
                          {/* Input row with upload button */}
                          <div className="flex items-end gap-2">
                            {/* Mobile: Show upload button with popover */}
                            <div className="relative upload-menu-container flex-shrink-0">
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => setIsUploadMenuOpen(!isUploadMenuOpen)}
                                className="p-2 h-10 w-10 flex items-center justify-center"
                                disabled={uploadingFiles.size > 0 || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                              >
                                {uploadingFiles.size > 0 ? (
                                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                                ) : (
                                  <Paperclip className="h-5 w-5" />
                                )}
                              </Button>

                              {/* Upload Menu Popover */}
                              {isUploadMenuOpen && (
                                <div className="absolute bottom-full left-0 mb-2 bg-white border rounded-lg shadow-lg p-2 z-10">
                                  <label htmlFor="mobile-image-upload" className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <ImageIcon className="h-4 w-4 text-green-600" />
                                    <span className="text-sm">{t("messagesAndVideoCall.photo")}</span>
                                  </label>
                                  <input
                                    id="mobile-image-upload"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleFileSelect}
                                    className="hidden"
                                  />

                                  <label htmlFor="mobile-file-upload" className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <Paperclip className="h-4 w-4 text-blue-600" />
                                    <span className="text-sm">{t("messagesAndVideoCall.file")}</span>
                                  </label>
                                  <input
                                    id="mobile-file-upload"
                                    type="file"
                                    multiple
                                    onChange={handleFileSelect}
                                    className="hidden"
                                  />
                                </div>
                              )}
                            </div>

                            <textarea
                              value={message}
                              onChange={handleInputChange}
                              placeholder={selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked ? t("messagesAndVideoCall.conversationBlocked") : t("messagesAndVideoCall.typeMessage")}
                              className="flex-1 px-3 py-2.5 text-sm border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px] max-h-[120px] resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
                              rows={1}
                              disabled={selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  handleSendMessage();
                                }
                              }}
                              onInput={(e) => {
                                // Auto-resize textarea based on content with max 5 lines
                                const target = e.target as HTMLTextAreaElement;
                                target.style.height = "auto";
                                const lineHeight = 24; // Approximate line height
                                const maxHeight = lineHeight * 5; // 5 lines max
                                target.style.height = Math.min(target.scrollHeight, maxHeight) + "px";
                              }}
                              onFocus={() => {
                                // Ensure scroll to bottom when input is focused on mobile
                                if (isMobileView) {
                                  setTimeout(() => {
                                    scrollToBottom();
                                  }, 300);
                                }
                              }}
                            />
                          </div>

                          {/* Send button and call buttons row */}
                          <div className="flex items-center justify-between gap-2">
                            {/* Call buttons */}
                            <div className="flex items-center gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleStartCall(CallType.AUDIO)}
                                title={!selectedChat ? "Select a chat first" : (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "Chat is blocked" : isCameraAccessDisabled() ? "Camera access denied" : "Audio Call"}
                                disabled={!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                                className={`p-2 h-10 w-10 ${(!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)) ? "opacity-50 cursor-not-allowed" : "text-green-600 hover:text-green-700 hover:bg-green-50"}`}
                              >
                                <Phone className="h-5 w-5" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleStartCall(CallType.VIDEO)}
                                title={!selectedChat ? "Select a chat first" : (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "Chat is blocked" : isCameraAccessDisabled() ? "Camera access denied" : "Video Call"}
                                disabled={!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                                className={`p-2 h-10 w-10 ${(!selectedChat || isCameraAccessDisabled() || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)) ? "opacity-50 cursor-not-allowed" : "text-blue-600 hover:text-blue-700 hover:bg-blue-50"}`}
                              >
                                <Video className="h-5 w-5" />
                              </Button>
                            </div>

                            {/* Send button */}
                            <Button
                              onClick={() => {
                                console.log("🔵 MOBILE SEND BUTTON CLICKED");
                                handleSendMessage();
                              }}
                              disabled={(!message.trim() && selectedFiles.length === 0) || uploadingFiles.size > 0 || isSendingMessage || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                              className="flex-1 max-w-[140px] h-10 px-4 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 active:scale-95 text-sm font-medium"
                            >
                              {uploadingFiles.size > 0 ? (
                                <div className="flex items-center gap-1.5">
                                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                  <span className="text-sm">{t("messagesAndVideoCall.uploading")}</span>
                                </div>
                              ) : isSendingMessage ? (
                                <div className="flex items-center gap-1.5">
                                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                  <span className="text-sm">{t("messagesAndVideoCall.sending")}</span>
                                </div>
                              ) : (
                                <div className="flex items-center gap-1.5">
                                  <Send className="h-4 w-4" />
                                  <span className="text-sm">{t("messagesAndVideoCall.send")}</span>
                                </div>
                              )}
                            </Button>
                          </div>
                        </div>

                        {/* Tablet/Desktop Layout: Inline */}
                        <div className="hidden sm:flex items-end gap-2 lg:gap-3">
                          {/* Tablet/Desktop: Show upload icons directly */}
                          <label htmlFor={chatImageUploadId} className={`flex-shrink-0 cursor-pointer ${uploadingFiles.size > 0 || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "opacity-50 cursor-not-allowed" : ""}`}>
                            <div className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                              {uploadingFiles.size > 0 ? (
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                              ) : (
                                <ImageIcon className="h-5 w-5 text-gray-600" />
                              )}
                            </div>
                          </label>
                          <input
                            id={chatImageUploadId}
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileSelect}
                            className="hidden"
                            disabled={uploadingFiles.size > 0 || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                          />
                          <label htmlFor={chatFileUploadId} className={`flex-shrink-0 cursor-pointer ${uploadingFiles.size > 0 || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked) ? "opacity-50 cursor-not-allowed" : ""}`}>
                            <div className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                              {uploadingFiles.size > 0 ? (
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                              ) : (
                                <Paperclip className="h-5 w-5 text-gray-600" />
                              )}
                            </div>
                          </label>
                          <input
                            id={chatFileUploadId}
                            type="file"
                            multiple
                            onChange={handleFileSelect}
                            className="hidden"
                            disabled={uploadingFiles.size > 0 || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                          />

                          <textarea
                            value={message}
                            onChange={handleInputChange}
                            placeholder={selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked ? t("messagesAndVideoCall.conversationBlocked") : t("messagesAndVideoCall.typeMessage")}
                            className="flex-1 px-4 py-2.5 text-sm md:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px] max-h-[120px] resize-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                            rows={1}
                            disabled={selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleSendMessage();
                              }
                            }}
                            onInput={(e) => {
                              // Auto-resize textarea based on content with max 5 lines
                              const target = e.target as HTMLTextAreaElement;
                              target.style.height = "auto";
                              const lineHeight = 24; // Approximate line height
                              const maxHeight = lineHeight * 5; // 5 lines max
                              target.style.height = Math.min(target.scrollHeight, maxHeight) + "px";
                            }}
                          />
                          <Button
                            onClick={() => {
                              console.log("🔵 DESKTOP SEND BUTTON CLICKED");
                              handleSendMessage();
                            }}
                            disabled={(!message.trim() && selectedFiles.length === 0) || uploadingFiles.size > 0 || isSendingMessage || (selectedChat?.chat?.status && Number(selectedChat.chat.status.id) === ChatStatusEnum.blocked)}
                            className="flex-shrink-0 h-[44px] px-4 lg:px-6 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-all duration-200 active:scale-95"
                          >
                            {uploadingFiles.size > 0 ? (
                              <div className="flex items-center gap-2">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                <span className="hidden lg:inline text-sm">{t("messagesAndVideoCall.uploading")}</span>
                              </div>
                            ) : isSendingMessage ? (
                              <div className="flex items-center gap-2">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                <span className="hidden lg:inline text-sm">{t("messagesAndVideoCall.sending")}</span>
                              </div>
                            ) : (
                              <div className="flex items-center gap-2">
                                <Send className="h-5 w-5" />
                                <span className="hidden lg:inline text-sm">{t("messagesAndVideoCall.send")}</span>
                              </div>
                            )}
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                // No Chat Selected State
                <div className="flex-1 flex items-center justify-center p-4 min-h-0">
                  <div className="text-center">
                    {loading && chats.length === 0 ? (
                      <>
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                        <h3 className="text-lg font-medium text-gray-900">{t("messagesAndVideoCall.loadingConversations")}</h3>
                      </>
                    ) : (
                      <>
                        <MessageSquare className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900">{t("messagesAndVideoCall.noConversationSelected")}</h3>
                        <p className="text-sm text-gray-500 mt-1">
                          {t("messagesAndVideoCall.chooseConversation")}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Profile Dialog */}
        {showProfileDialog && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
              <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900">
                  {user?.role?.id === "2" ? t("messagesAndVideoCall.professionalProfile") : t("messagesAndVideoCall.clientProfile")}
                </h2>
                <button
                  onClick={handleCloseProfileDialog}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
              <div className="p-4 overflow-y-auto max-h-[calc(90vh-8rem)]">
                {user?.role?.id === "2" ? (
                  <div className="text-center py-8">
                    {selectedProfessional ? (
                      <MyProfile
                        isAdminEdit={true}
                        isViewing={true}
                        adminUserId={selectedProfessional.id}
                        onUserUpdated={() => {
                          // Refresh the professionals list if needed
                          // handleSearch();
                        }}
                      />
                    ) : (
                      <div className="text-center py-8">
                        <User className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">{t("messagesAndVideoCall.noProfessionalFound")}</h3>
                        <p className="text-gray-500">{t("messagesAndVideoCall.noProfessionalParticipant")}</p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-8">
                    {selectedClient ? (
                      <ClientProfile1
                        isAdminEdit={true}
                        adminUserId={selectedClient.id}
                        canEdit={false}
                      // onUserUpdated={onUserUpdated}
                      />
                    ) : (
                      <div className="text-center py-8">
                        <User className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">{t("messagesAndVideoCall.noClientFound")}</h3>
                        <p className="text-gray-500">{t("messagesAndVideoCall.noClientParticipant")}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Offer Details Dialog */}
        {showOfferDialog && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[85vh] overflow-y-auto">
              <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900">{t("messagesAndVideoCall.quoteDetails")}</h2>
                <button
                  onClick={() => setShowOfferDialog(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
              <div className="p-4 space-y-3 text-sm text-gray-700">
                <div className="flex justify-between">
                  <span className="text-gray-500">{t("messagesAndVideoCall.offerId")}</span>
                  <span className="font-medium">{offerDetails?.id || "-"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">{t("messagesAndVideoCall.title")}</span>
                  <span className="font-medium">{offerDetails?.title || offerDetails?.job?.title || "-"}</span>
                </div>
                <div>
                  <div className="text-gray-500 mb-1">{t("messagesAndVideoCall.description")}</div>
                  <div className="whitespace-pre-wrap">{offerDetails?.description || "-"}</div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex justify-between">
                    <span className="text-gray-500">{t("messagesAndVideoCall.amountLabel")}</span>
                    <span className="font-medium">{offerDetails?.amount || offerDetails?.job?.budget || "-"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">{t("messagesAndVideoCall.currency")}</span>
                    <span className="font-medium">{offerDetails?.job?.currency?.initial || offerDetails?.currency?.initial || offerDetails?.job?.currency?.name || offerDetails?.currency?.name || "-"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">{t("messagesAndVideoCall.timelineLabel")}</span>
                    <span className="font-medium">{offerDetails?.timeline ? `${offerDetails.timeline} ${offerDetails?.timelineType?.name || "days"}` : "-"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">{t("messagesAndVideoCall.statusLabel")}</span>
                    <span className="font-medium">{offerDetails?.status?.name || offerDetails?.status?.id || "-"}</span>
                  </div>
                </div>
                {offerDetails?.files && offerDetails.files.length > 0 && (
                  <div className="mt-2">
                    <div className="text-gray-500 mb-1">{t("messagesAndVideoCall.attachments")}</div>
                    <div className="space-y-2">
                      {offerDetails.files.map((f: any, idx: number) => (
                        <div key={idx} className="flex items-center gap-2 text-sm">
                          <FileText className="h-4 w-4 text-gray-400" />
                          <a href={f?.path || f?.url || "#"} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline truncate">
                            {f?.name || f?.path?.split("/").pop() || `File-${idx + 1}`}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="p-4 border-t flex justify-end">
                <Button
                  variant="outline"
                  onClick={() => setShowOfferDialog(false)}
                >
                  {t("messagesAndVideoCall.close")}
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Quote Modal */}
        {showQuoteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full">
              <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900">
                  {Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional 
                    ? t("messagesAndVideoCall.createOffer")
                    : t("messagesAndVideoCall.requestQuote")}
                </h2>
                <button
                  onClick={handleCloseQuoteModal}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
              <div className="p-4">
                {(() => {
                  const isProfessionalUser = Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional;
                  const isClientUser = Number(user?.role?.id) === RoleEnum.client || Number(user?.role?.id) === RoleEnum.internationl_client;
                  
                  // Determine the professional participant based on current user role
                  // If current user is professional → professional prop should be current user
                  // If current user is client → professional prop should be the other participant (professional)
                  const professionalParticipant = isProfessionalUser ? user : selectedProfessional;
                  
                  // For error checking: check if we have the recipient we need
                  // Professionals send offers TO clients, so they need a client
                  // Clients request quotes FROM professionals, so they need a professional
                  const recipientParticipant = isProfessionalUser ? selectedClient : selectedProfessional;
                  
                  if (!recipientParticipant) {
                    return (
                      <div className="text-center py-8">
                        <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          {isProfessionalUser ? t("messagesAndVideoCall.noClientFound") : t("messagesAndVideoCall.noProfessionalFound")}
                        </h3>
                        <p className="text-gray-500">
                          {isProfessionalUser 
                            ? t("messagesAndVideoCall.noClientParticipant")
                            : t("messagesAndVideoCall.noProfessionalParticipant")}
                        </p>
                      </div>
                    );
                  }
                  
                  return (
                    <RequestQuoteModal
                      isOpen={true}
                      onClose={handleCloseQuoteModal}
                      professional={{ 
                        id: professionalParticipant?.id || "", 
                        name: professionalParticipant?.name || 
                              (professionalParticipant?.firstName && professionalParticipant?.lastName 
                                ? `${professionalParticipant.firstName} ${professionalParticipant.lastName}` 
                                : professionalParticipant?.firstName || professionalParticipant?.email || "User")
                      }}
                      isProfessional={isProfessionalUser}
                      isSentDefault={!isProfessionalUser}
                      restrictOfferIds={isProfessionalUser
                        ? ((conversations && conversations.length > 0) ? conversations : messages)
                          .filter((c: any) => Number((c as any)?.type?.id) === ConversationTypeEnum.Quote && ((((c as any)?.referenceId) || ((c as any)?.reference?.id) || ((c as any)?.referenceID))))
                          .map((c: any) => String(((c as any)?.referenceId) || ((c as any)?.reference?.id) || ((c as any)?.referenceID)))
                        : []}
                      onOfferCreated={async (offer: any) => {
                        if (isProfessionalUser) {
                          // Professional: Send the offer as a message in the current chat
                          await handleSendMessage(offer?.description, selectedChat.chat, true, offer?.id);
                        } else {
                          // Client: Navigate to professional's chat with the offer
                          const profId = selectedProfessional?.id;
                          const profName = selectedProfessional?.name || 
                                          (selectedProfessional?.firstName && selectedProfessional?.lastName 
                                            ? `${selectedProfessional.firstName} ${selectedProfessional.lastName}` 
                                            : selectedProfessional?.firstName || "Professional");
                          if (profId) {
                            navigate(`/client/MessageAndVideoCall?professionalId=${profId}&professionalName=${encodeURIComponent(profName)}&offerId=${offer.id}`);
                          }
                        }
                        handleCloseQuoteModal();
                      }}
                      onOfferUpdated={(updatedOffer) => {
                        // Handle quote update success
                        handleCloseQuoteModal();
                      }}
                    />
                  );
                })()}
              </div>
            </div>
          </div>
        )}

        {/* Contract Detail Modal */}
        <ContractDetailModal
          isOpen={showContractDetailModal}
          onClose={handleCloseContractDetailModal}
          escrow={selectedContractEscrow}
          loading={loading}
          onRefresh={handleRefreshChatData}
          hideContactClientButton={true}
          canAcceptDeclineContract={(escrow) => {
            if (!escrow?.contract) return false;
            // Convert escrow to order format for the shared utility
            const order = {
              status: escrow.contract.status?.id,
              milestones: escrow.milestone ? [escrow.milestone] : [],
              paymentStatus: escrow.status?.id === EscrowStatus.FUNDED ? "paid" : "pending",
              isHourly: Number(escrow.contract.type?.id) === 2,
              enableTracker: escrow.contract.enableTracker
            };
            return canAcceptDeclineContract(order);
          }}
          requiresTrackerCheckbox={(escrow) => {
            if (!escrow?.contract) return false;
            // Convert escrow to order format for the shared utility
            const order = {
              isHourly: Number(escrow.contract.type?.id) === 2,
              enableTracker: escrow.contract.enableTracker
            };
            return requiresTrackerCheckbox(order);
          }}
          trackerCheckboxStates={{}}
          handleTrackerCheckboxChange={(contractId, checked) => {
            // Handle tracker checkbox change if needed
            console.log("Tracker checkbox changed:", contractId, checked);
          }}
          handleContractAction={async (contractId, action) => {
            try {
              // Find the contract and milestone data
              const contract = selectedContractEscrow?.contract;
              if (!contract) return;

              const milestone = selectedContractEscrow?.milestone;
              if (!milestone) {
                alert("No milestone found for this contract");
                return;
              }

              // Show confirmation for decline action
              if (action === "decline") {
                const confirmed = window.confirm(
                  "Are you sure you want to decline this contract? This action will:\n\n" +
                  "• Mark the contract as rejected\n" +
                  "• Mark the first milestone as rejected\n" +
                  "• Refund the escrow payment to the client\n\n" +
                  "This action cannot be undone. Do you want to continue?"
                );

                if (!confirmed) {
                  return;
                }
              }

              // Use the shared utility function
              await defaultHandleContractAction(contractId, action, [contract], (contractId, action) => {
                // Success callback
                handleCloseContractDetailModal();
              });
            } catch (error) {
              console.error("Error handling contract action:", error);
              alert("Failed to update contract. Please try again.");
            }
          }}
          setShowServicesDialog={(show) => {
            // Handle showing services dialog if needed
            console.log("Show services dialog:", show);
          }}
        />

        {/* Payment Request Modal */}
        <PaymentRequestModal
          isOpen={showPaymentRequestModal}
          onClose={handleClosePaymentRequestModal}
          paymentRequest={selectedPaymentRequest}
          loading={loading}
          milestoneId={selectedMilestoneId || undefined}
        />

        {/* Offer Details Modal */}
        {showOfferDetailsModal && selectedOfferDetails && (
          <OfferDetailsModal
            offer={selectedOfferDetails}
            onClose={(messageData) => {

              setShowOfferDetailsModal(false);
              setSelectedOfferDetails(null);

              // Refresh chat and conversation data

            }}
            activeTab="received"
            onRefresh={(messageData) => {
              console.log("messageData11", messageData);
              if (messageData) {
                setConversations(messageData);
              }
              // Refresh data if needed
              console.log("Refreshing offer data");
            }}
            hideDeleteButtons={true}
          />
        )}

        {/* Client Offer Details Modal */}
        {showClientOfferModal && selectedClientOffer && (
          <ClientOfferDetailsModal
            isOpen={showClientOfferModal}
            onClose={() => {
              setShowClientOfferModal(false);
              setSelectedClientOffer(null);
            }}
            offer={selectedClientOffer}
            categoryFormSettings={categoryFormSettings}
            showActions={true}
            onOfferUpdated={() => {
              // Refresh conversations and chat data
              if (user?.id) {
                dispatch(fetchParticipantChats({ currentUserId: user.id, page: 1, limit: 10 }));
              }
              // Refresh conversations if needed
              if (conversations && conversations.length > 0) {
                // You can add specific conversation refresh logic here if needed
                console.log("Refreshing conversations after offer update");
              }
            }}
            currentPage={1}
            pageSize={10}
            selectedTab="received"
            searchTerm=""
            filters={{}}
            userId={user?.id}
          />
        )}

        {/* Create Contract Modal */}
        {showCreateContractModal && selectedOfferForContract && (
          <ContractMilestoneModal
            isOpen={showCreateContractModal}
            onClose={handleCloseCreateContractModal}
            offer={selectedOfferForContract}
          />
        )}

        {/* Contract Milestone Modal */}
        <ContractMilestoneModal
          isOpen={showContractMilestoneModal}
          onClose={handleCloseContractMilestoneModal}
          offer={selectedContractOffer}
          clientOffers={clientOffers}
          onOfferSelect={(offer) => {
            setSelectedContractOffer(offer);
          }}
        />

        {/* Rejection Details Dialog */}
        <RejectionDetailsDialog
          isOpen={showRejectionDialog}
          onClose={() => {
            setShowRejectionDialog(false);
            setSelectedRejectionData(null);
          }}
          rejectionData={selectedRejectionData}
          onRequestAgain={(escrow) => {
            // Use the same payment request logic as OrderDetailsModal
            handleRequestPaymentRelease(escrow);
            setShowRejectionDialog(false);
            setSelectedRejectionData(null);
          }}
        />
      </main>
      {/* <SharedFooter3 /> */}

      {/* Profile Completion Dialog */}
      <ProfileCompletionDialog
        isOpen={showProfileCompletionDialog}
        onClose={() => setShowProfileCompletionDialog(false)}
        onGoToProfile={navigateToProfile}
        userRole={Number(user?.role?.id)}
      />

      {/* Verification Requirement Dialog */}
      <VerificationRequirementDialog
        isOpen={showVerificationDialog}
        onClose={() => setShowVerificationDialog(false)}
        title="Verification Required"
        message="Please complete your account verification to make video and audio calls."
      />

      {/* Chat Safety Notice Dialog */}
      <ChatSafetyNoticeDialog
        isOpen={showChatSafetyNotice}
        onAccept={handleAcceptSafetyNotice}
      />
    </div>
  );
};

export default MessagesAndVideoCall2;